export const GF_COLUMN_TRANSLATIONS = {
  English: {
    "1128": "Consent Language",
    "1132": "Consent Signed Section",
    "1131": "Action Type",
    "1133": "Consent Signed For",
    "1134": "Consent Signed by",
    "1135": "Consent Attachment",
    "1136": "Revocation Reason",
    "1137": "Date",
    "1138": "Revocation Effective Date",
    "1282": "Consent Not Signed For",
    "1283": "Guardian's Name",
    "1284": "Guardian's Relationship",
    "1139": "Consent Final Status",
    "1140": "Case Received Date",
    "1141": "Case Source",
    "1142": "If other, Pls Specify",
    "1143": "Screening Camp GF Supported",
    "1144": "Screening Camp Hospital Location",
    "1145": "Out Reach OPD Location",
    "1146": "Referred Hospital Name",
    "1147": "Referred Hospital Location",
    "1148": "Beneficiary Full Name",
    "1149": "Alias Name",
    "1150": "Age Value",
    "1151": "Age Unit(In days/Months/Years)",
    "1152": "Age Category",
    "1153": "Gender",
    "1154": "Religion",
    "1155": "Body Weight (Kg)",
    "1156": "Education Status",
    "1157": "Name of School/College",
    "1158": "Beneficiary ID Proof",
    "1159": "Aadhar Card Number",
    "1160": "Aadhar Card Verified by Hospital?",
    "1161": "Birth Certificate Shared with GF",
    "1162": "Verification form filled & Signed by Hospital",
    "1163": "Parent Status",
    "1164": "Child Living With",
    "1165": "Name of Mother",
    "1166": "Mother's Age",
    "1167": "Mother's Profession",
    "1168": "Mother's Monthly Income",
    "1169": "Name of Father",
    "1170": "Father's Age",
    "1171": "Father's Profession",
    "1172": "Father's Monthly Income",
    "1173": "Name of Guardian",
    "1174": "Guardian's Age",
    "1175": "Guardian's Profession",
    "1176": "Guardian's Monthly Income",
    "1177": "Total Family Income",
    "1178": "Address Source",
    "1179": "Full Address",
    "1180": "Primary Contact Person",
    "1181": "Primary Contact Number",
    "1182": "Alternate Contact Number",
    "1183": "No. of Siblings of Beneficiary",
    "1184": "Permanent Address of Beneficiary",
    "1185": "State",
    "1186": "Parent/Guardian Taluka",
    "1206": "District",
    "1207": "Is Aspirational District?",
    "1208": "Village/Area Name",
    "1209": "Geography Classification",
    "1210": "Tribal Belt",
    "1211": "A Congenital Heart Defects Case?",
    "1212": "Pre-Surgery Symptoms",
    "1213": "Case Type",
    "1229": "Diagnosis",
    "1230": "Treatment Prescribed",
    "1231": "Type of Surgery",
    "1232": "A VSD Device Closure?",
    "1233": "A Single Ventricle Physiology?",
    "1234": "A Hypoplastic Heart?",
    "1235": "A CHD Case with Down's Syndrome or other major genetic condition?",
    "1236": "In requirement of a Heart Transplant?",
    "1237": "A Re-do Surgery?",
    "1238": "A Valve Repair/Replacement?",
    "1239": "Has this child been supported by GF Before?",
    "1240": "Brief medical details of the Beneficiary",
    "1241": "Estimated Cost of Surgery",
    "1242": "Estimated Family Contribution",
    "1243": "Estimated Hospital Discount",
    "1244": "Family Contribution Source",
    "1245": "Estimated Hospital Charity Cell Contribution",
    "1246": "Other Contribution Amount",
    "1247": "Hospital Charity Cell - Comments",
    "1248": "Other Contribution - Comments",
    "1249": "Other Contribution - Files",
    "1250": "Maximum GF Contribution",
    "1251": "Hospital Name",
    "1252": "Treating Doctor",
    "1253": "I have been given a copy of the consent form, application form and declaration form",
    "1254": "The information given above is true and complete",
    "1255": "I am not able to afford the expense for the treatment of my child (Beneficiary) described above",
    "1263": "I acknowledge that the financial and other assistance for the treatment of the child is being provided as a gratuitous and philanthropic gesture. I confirm that Genesis Foundation, its trustees, officers, employees, and volunteers, will have no liability in respect of the treatment of my child including hospitalisation, surgical or other procedures, and medication. I hereby waive all claims, if any, concerning the treatment. I hereby indemnify Genesis Foundation, its trustees, employees, and volunteers against any claims that may be raised by anyone with respect to the subject matter.",
    "1257": "Do the Parent(s)/Guardian agree to all the above declarations?",
    "1258": "Application form filled by",
    "1259": "Designation",
    "1260": "Birth Certificate Document",
    "1261": "Pre-Surgery Beneficiary Photo",
    "1264": "I confirm that a valid birth certificate has been submitted. Therefore, verification details for the beneficiary are not required and the verification section may be skipped.",
    "1265": "Name of the Beneficiary",
    "1266": "Beneficiary Gender",
    "1267": "Beneficiary ID Proof Verification",
    "1269": "Beneficiary Mother's Name",
    "1270": "Mother's Aadhaar & Voter Id Verification",
    "1271": "Mother's Voter ID Verification",
    "1272": "Beneficiary Father's Name",
    "1273": "Father's Aadhaar & Voter Id Verification",
    "1274": "Father's Voter ID Verification",
    "1275": "Name of Earning Family Member",
    "1276": "Monthly Income",
    "1277": "Yearly Income",
    "1278": "Language of Income Proof Submitted",
    "1279": "Hospital Representative Name",
    "1280": "Hospital Representative Designation",
    "1281": "I, {name}, of designation {designation} have seen each Aadhaar Card/Voter ID and Income proof (inclusive of ones in vernacular languages) mentioned above and also ensure that details match those in the Application Form.",
    "1285": "Higher Education Qualification",
    "1286": "Mother's Id Proof Type",
    "1287": "Father's Id Proof Type",
    "1288": "Guardian's Id Proof Type",
    "1289": "Mother's Aadhar Card Number",
    "1290": "Mother's Voter Card Number",
    "1291": "Father's Aadhar Card Number",
    "1292": "Father's Voter Card Number",
    "1293": "Guardian's Aadhar Card Number",
    "1294": "Guardian's Voter Card Number",
    "1295": "Guardian's Relationship",
    "1296": "Congenital Heart Defects Case - Comments - Please Specify",
    "1297": "Echo Report Document",
    "1298": "Estimate Letter Document",
    "1299": "Income Proof Document",
    "1300": "Family Photo",
    "1301": "Guardian's Aadhaar & Voter Id Verification",
  },

  Assamese: {
    "1128": "সন্মতিৰ ভাষা",
    "1132": "সন্মতি স্বাক্ষৰিত অংশ",
    "1131": "কাৰ্য্যৰ প্ৰকাৰ",
    "1133": "যাৰ বাবে সন্মতি স্বাক্ষৰিত",
    "1134": "সন্মতি স্বাক্ষৰকাৰী",
    "1135": "সন্মতি সংলগ্ন নথি",
    "1136": "প্ৰত্যাহাৰৰ কাৰণ",
    "1137": "তাৰিখ",
    "1138": "প্ৰত্যাহাৰ কাৰ্যকৰী হোৱাৰ তাৰিখ",
    "1282": "যাৰ বাবে সন্মতি স্বাক্ষৰিত নহয়",
    "1283": "অভিভাৱকৰ নাম",
    "1284": "অভিভাৱকৰ সম্পৰ্ক",
    "1139": "সন্মতিৰ চূড়ান্ত স্থিতি",
    "1140": "গোচৰ প্ৰাপ্তিৰ তাৰিখ",
    "1141": "গোচৰৰ উৎস",
    "1142": "যদি অন্য, অনুগ্ৰহ কৰি উল্লেখ কৰক",
    "1143": "GF সমৰ্থিত স্ক্ৰীনিং শিবিৰ",
    "1144": "স্ক্ৰীনিং শিবিৰ চিকিৎসালয়ৰ স্থান",
    "1145": "আউটৰিচ OPD স্থান",
    "1146": "প্ৰেৰিত চিকিৎসালয়ৰ নাম",
    "1147": "প্ৰেৰিত চিকিৎসালয়ৰ স্থান",
    "1148": "সুবিধাভোগীৰ সম্পূৰ্ণ নাম",
    "1149": "উপনাম / আন নাম",
    "1150": "বয়সৰ মান",
    "1151": "বয়সৰ একক (দিন/মাহ/বছৰত)",
    "1152": "বয়সৰ শ্ৰেণী",
    "1153": "লিংগ",
    "1154": "ধৰ্ম",
    "1155": "শৰীৰৰ ওজন (কিলোগ্ৰাম)",
    "1156": "শিক্ষাৰ স্থিতি",
    "1157": "বিদ্যালয়/মহাবিদ্যালয়ৰ নাম",
    "1158": "সুবিধাভোগীৰ পৰিচয়পত্ৰৰ প্ৰমাণ",
    "1159": "আধাৰ কাৰ্ড নম্বৰ",
    "1160": "আধাৰ কাৰ্ড চিকিৎসালয়ৰ দ্বাৰা পৰীক্ষিত?",
    "1161": "জন্ম প্ৰমাণপত্ৰ GF ৰ সৈতে ভাগ বতৰা",
    "1162": "যাচাইকৰণ ফৰ্ম চিকিৎসালয়ৰ দ্বাৰা পূৰণ আৰু স্বাক্ষৰিত",
    "1163": "পিতামাতাৰ স্থিতি",
    "1164": "শিশু কাৰ সৈতে বাস কৰে",
    "1165": "মাতৃৰ নাম",
    "1166": "মাতৃৰ বয়স",
    "1167": "মাতৃৰ বৃত্তি",
    "1168": "মাতৃৰ মাহেকীয়া আয়",
    "1169": "পিতৃৰ নাম",
    "1170": "পিতৃৰ বয়স",
    "1171": "পিতৃৰ বৃত্তি",
    "1172": "পিতৃৰ মাহেকীয়া আয়",
    "1173": "অভিভাৱকৰ নাম",
    "1174": "অভিভাৱকৰ বয়স",
    "1175": "অভিভাৱকৰ বৃত্তি",
    "1176": "অভিভাৱকৰ মাহেকীয়া আয়",
    "1177": "পৰিয়ালৰ মুঠ আয়",
    "1178": "ঠিকনাৰ উৎস",
    "1179": "সম্পূৰ্ণ ঠিকনা",
    "1180": "প্ৰাথমিক যোগাযোগৰ ব্যক্তি",
    "1181": "প্ৰাথমিক যোগাযোগৰ নম্বৰ",
    "1182": "বিকল্প যোগাযোগৰ নম্বৰ",
    "1183": "সুবিধাভোগীৰ ভাই-ভনীৰ সংখ্যা",
    "1184": "সুবিধাভোগীৰ স্থায়ী ঠিকনা",
    "1185": "ৰাজ্য",
    "1186": "পিতামাতা/অভিভাৱকৰ অঞ্চল",
    "1206": "জিলা",
    "1207": "আকাংক্ষামূলক জিলা নে?",
    "1208": "গাঁও/এলেকাৰ নাম",
    "1209": "ভৌগোলিক শ্ৰেণীবিভাজন",
    "1210": "জনজাতীয় অঞ্চল",
    "1211": "জন্মগত হৃদৰোগৰ গোচৰ হয়নে?",
    "1212": "অস্ত্ৰোপচাৰৰ আগৰ লক্ষণসমূহ",
    "1213": "গোচৰৰ ধৰণ",
    "1229": "ৰোগ নিৰ্ণয়",
    "1230": "নিৰ্ধাৰিত চিকিৎসা",
    "1231": "অস্ত্ৰোপচাৰৰ প্ৰকাৰ",
    "1232": "ভিএছডি ডিভাইচ ক্ল'জাৰ হয়নে?",
    "1233": "একক ভেন্ট্ৰিকল ফিজিঅ'লজি হয়নে?",
    "1234": "হাইপ'প্লাষ্টিক হাৰ্ট হয়নে?",
    "1235": "ডাউন চিনড্ৰ'ম বা অন্য গুৰুতৰ জিনীয় অৱস্থাৰ সৈতে চিএইচডিৰ গোচৰ নেকি?",
    "1236": "হৃদযন্ত্ৰ সংৰোপণৰ প্ৰয়োজন আছে নেকি?",
    "1237": "পুনৰ অস্ত্ৰোপচাৰ (ৰি-ডু) হয়নে?",
    "1238": "ভালভ মেৰামতি/প্ৰতিস্থাপন হয়নে?",
    "1239": "এই শিশুটিক পূৰ্বে জিএফৰ দ্বাৰা সহায় কৰা হৈছিল নেকি?",
    "1240": "সুবিধাভোগীৰ চমু চিকিৎসা বিৱৰণ",
    "1241": "অস্ত্ৰোপচাৰৰ আনুমানিক খৰচ",
    "1242": "পৰিয়ালৰ আনুমানিক অৱদান",
    "1243": "চিকিৎসালয়ৰ আনুমানিক ৰেহাই",
    "1244": "পৰিয়ালৰ অৱদানৰ উৎস",
    "1245": "চিকিৎসালয় চেৰিটি চেলৰ আনুমানিক অৱদান",
    "1246": "অন্য অৱদানৰ পৰিমাণ",
    "1247": "চিকিৎসালয় চেৰিটি চেল - মন্তব্য",
    "1248": "অন্য অৱদান - মন্তব্য",
    "1249": "অন্য অৱদান - ফাইলসমূহ",
    "1250": "জিএফৰ সৰ্বাধিক অৱদান",
    "1251": "চিকিৎসালয়ৰ নাম",
    "1252": "চিকিৎসা কৰা চিকিৎসক",
    "1253": "মোক সন্মতি ফৰ্ম, আবেদন ফৰ্ম আৰু ঘোষণা ফৰ্মৰ এটা কপি দিয়া হৈছে",
    "1254": "ওপৰত দিয়া তথ্য সত্য আৰু সম্পূৰ্ণ",
    "1255": "ওপৰত উল্লেখ কৰা মোৰ সন্তানৰ (সুবিধাভোগী) চিকিৎসাৰ ব্যয় বহন কৰিবলৈ মই সক্ষম নহয়",
    "1263": "মই স্বীকাৰ কৰিছো যে শিশুটিৰ চিকিৎসাৰ বাবে আৰ্থিক আৰু অন্যান্য সহায় এক বিনামূলীয়া আৰু পৰোপকাৰী মনোভাৱেৰে প্ৰদান কৰা হৈছে। মই নিশ্চিত কৰিছো যে জেনেছিছ ফাউণ্ডেশ্যন, ইয়াৰ ন্যাসকৰ্তাসকল, বিষয়া, কৰ্মচাৰী, আৰু স্বেচ্ছাসেৱকসকল মোৰ শিশুৰ চিকিৎসাৰ সম্পৰ্কত কোনো দায়িত্বশীল নহ'ব। মই এতদ্বাৰা চিকিৎসাৰ সৈতে জড়িত যিকোনো দাবী ত্যাগ কৰিছো।",
    "1257": "পিতামাতা/অভিভাৱকে ওপৰৰ সকলো ঘোষণাত সন্মতি দিছেনে?",
    "1258": "আবেদন ফৰ্ম পূৰণ কৰা ব্যক্তি",
    "1259": "পদবী",
    "1260": "জন্ম প্ৰমাণপত্ৰ নথিপত্ৰ",
    "1261": "অস্ত্ৰোপচাৰৰ আগৰ সুবিধাভোগীৰ ছবি",
    "1264": "মই নিশ্চিত কৰিছো যে এটি বৈধ জন্ম প্ৰমাণপত্ৰ দাখিল কৰা হৈছে। সেয়েহে, সুবিধাভোগীৰ যাচাইকৰণ বিৱৰণৰ প্ৰয়োজন নাই আৰু যাচাইকৰণ অংশ এৰিব পাৰি।",
    "1265": "সুবিধাভোগীৰ নাম",
    "1266": "সুবিধাভোগীৰ লিঙ্গ",
    "1267": "সুবিধাভোগীৰ পৰিচয়পত্ৰ প্ৰমাণ যাচাইকৰণ",
    "1269": "সুবিধাভোগীৰ মাতৃৰ নাম",
    "1270": "মাতৃৰ আধাৰ আৰু ভোটাৰ আইডি যাচাইকৰণ",
    "1271": "মাতৃৰ ভোটাৰ আইডি যাচাইকৰণ",
    "1272": "সুবিধাভোগীৰ পিতৃৰ নাম",
    "1273": "পিতৃৰ আধাৰ আৰু ভোটাৰ আইডি যাচাইকৰণ",
    "1274": "পিতৃৰ ভোটাৰ আইডি যাচাইকৰণ",
    "1275": "উপাৰ্জনকাৰী পৰিয়ালৰ সদস্যৰ নাম",
    "1276": "মাহিলি আয়",
    "1277": "বাৰ্ষিক আয়",
    "1278": "দাখিল কৰা আয়ৰ প্ৰমাণৰ ভাষা",
    "1279": "চিকিৎসালয়ৰ প্ৰতিনিধিৰ নাম",
    "1280": "চিকিৎসালয়ৰ প্ৰতিনিধিৰ পদ",
    "1281": "মই, {name}, পদ {designation}, ওপৰত উল্লেখ কৰা প্ৰতিটো আধাৰ কাৰ্ড/ভোটাৰ আইডি আৰু আয়ৰ প্ৰমাণপত্ৰ (স্থানীয় ভাষাত থকাসমূহ ধৰি) প্ৰত্যক্ষ কৰিছোঁ আৰু আবেদন পত্ৰৰ তথ্যৰ সৈته এইসমূহ মিলি থকাটো নিশ্চিত কৰিছোঁ।",
    "1285": "উচ্চ শিক্ষাৰ যোগ্যতা",
    "1286": "মাতৃৰ পৰিচয়পত্ৰৰ প্ৰকাৰ",
    "1287": "পিতৃৰ পৰিচয়পত্ৰৰ প্ৰকাৰ",
    "1288": "অভিভাৱকৰ পৰিচয়পত্ৰৰ প্ৰকাৰ",
    "1289": "মাতৃৰ আধাৰ কাৰ্ড নম্বৰ",
    "1290": "মাতৃৰ ভোটাৰ কাৰ্ড নম্বৰ",
    "1291": "পিতৃৰ আধাৰ কাৰ্ড নম্বৰ",
    "1292": "পিতৃৰ ভোটাৰ কাৰ্ড নম্বৰ",
    "1293": "অভিভাৱকৰ আধাৰ কাৰ্ড নম্বৰ",
    "1294": "অভিভাৱকৰ ভোটাৰ কাৰ্ড নম্বৰ",
    "1295": "অভিভাৱকৰ সম্পৰ্ক",
    "1296": "জন্মগত হৃদৰোগৰ গোচৰ - মন্তব্য - অনুগ্ৰহ কৰি উল্লেখ কৰক",
    "1297": "ইকো ৰিপোৰ্ট নথিপত্ৰ",
    "1298": "আনুমানিক পত্ৰ নথিপত্ৰ",
    "1299": "আয়ৰ প্ৰমাণ নথিপত্ৰ",
    "1300": "পৰিয়ালৰ ছবি",
    "1301": "অভিভাৱকৰ আধাৰ আৰু ভোটাৰ আইডি যাচাইকৰণ",
  },

  Bengali: {
    "1128": "সম্মতির ভাষা",
    "1132": "সম্মতি স্বাক্ষরিত বিভাগ",
    "1131": "পদক্ষেপের ধরন",
    "1133": "যার জন্য সম্মতি স্বাক্ষরিত",
    "1134": "সম্মতি স্বাক্ষরকারী",
    "1135": "সম্মতি সংযুক্তি",
    "1136": "প্রত্যাহারের কারণ",
    "1137": "তারিখ",
    "1138": "প্রত্যাহার কার্যকর হওয়ার তারিখ",
    "1282": "যার জন্য সম্মতি স্বাক্ষরিত নয়",
    "1283": "অভিভাবকের নাম",
    "1284": "অভিভাবকের সম্পর্ক",
    "1139": "সম্মতির চূড়ান্ত অবস্থা",
    "1140": "মামলা প্রাপ্তির তারিখ",
    "1141": "মামলার উৎস",
    "1142": "যদি অন্য, অনুগ্রহ করে উল্লেখ করুন",
    "1143": "GF সমর্থিত স্ক্রিনিং শিবির",
    "1144": "স্ক্রিনিং শিবির হাসপাতালের অবস্থান",
    "1145": "আউটরিচ OPD অবস্থান",
    "1146": "রেফারকৃত হাসপাতালের নাম",
    "1147": "রেফারকৃত হাসপাতালের অবস্থান",
    "1148": "সুবিধাভোগীর পূর্ণ নাম",
    "1149": "উপনাম / ওরফে নাম",
    "1150": "বয়সের মান",
    "1151": "বয়সের একক (দিন/মাস/বছরে)",
    "1152": "বয়স বিভাগ",
    "1153": "লিঙ্গ",
    "1154": "ধর্ম",
    "1155": "শরীরের ওজন (কেজি)",
    "1156": "শিক্ষার অবস্থা",
    "1157": "স্কুল/কলেজের নাম",
    "1158": "সুবিধাভোগীর পরিচয়পত্র প্রমাণ",
    "1159": "আধার কার্ড নম্বর",
    "1160": "হাসপাতাল কর্তৃক আধার কার্ড যাচাই করা হয়েছে?",
    "1161": "জন্ম সনদ GF-এর সাথে শেয়ার করা হয়েছে",
    "1162": "যাচাইকরণ ফর্ম হাসপাতাল কর্তৃক পূরণ ও স্বাক্ষরিত",
    "1163": "পিতামাতার অবস্থা",
    "1164": "শিশু কার সাথে বসবাস করছে",
    "1165": "মায়ের নাম",
    "1166": "মায়ের বয়স",
    "1167": "মায়ের পেশা",
    "1168": "মায়ের মাসিক আয়",
    "1169": "বাবার নাম",
    "1170": "বাবার বয়স",
    "1171": "বাবার পেশা",
    "1172": "বাবার মাসিক আয়",
    "1173": "অভিভাবকের নাম",
    "1174": "অভিভাবকের বয়স",
    "1175": "অভিভাবকের পেশা",
    "1176": "অভিভাবকের মাসিক আয়",
    "1177": "পরিবারের মোট আয়",
    "1178": "ঠিকানার উৎস",
    "1179": "সম্পূর্ণ ঠিকানা",
    "1180": "প্রাথমিক যোগাযোগ ব্যক্তি",
    "1181": "প্রাথমিক যোগাযোগ নম্বর",
    "1182": "বিকল্প যোগাযোগ নম্বর",
    "1183": "সুবিধাভোগীর ভাইবোনের সংখ্যা",
    "1184": "সুবিধাভোগীর স্থায়ী ঠিকানা",
    "1185": "রাজ্য",
    "1186": "পিতামাতা/অভিভাবকের অঞ্চল",
    "1206": "জেলা",
    "1207": "এটি কি আকাঙ্ক্ষামূলক জেলা?",
    "1208": "গ্রাম/এলাকার নাম",
    "1209": "ভৌগোলিক শ্রেণিবিন্যাস",
    "1210": "উপজাতি অঞ্চল",
    "1211": "এটি কি একটি জন্মগত হৃদরোগের মামলা?",
    "1212": "অস্ত্রোপচারপূর্ব লক্ষণসমূহ",
    "1213": "মামলার ধরন",
    "1229": "রোগ নির্ণয়",
    "1230": "নির্ধারিত চিকিৎসা",
    "1231": "অস্ত্রোপচারের ধরন",
    "1232": "এটি কি একটি ভিএসডি ডিভাইস ক্লোজার?",
    "1233": "এটি কি একটি সিঙ্গল ভেন্ট্রিকল ফিজিওলজি?",
    "1234": "এটি কি একটি হাইপোপ্লাস্টিক হার্ট?",
    "1235": "ডাউন সিন্ড্রোম বা অন্য কোনো প্রধান জেনেটিক অবস্থা সহ সিএইচডি মামলা?",
    "1236": "হার্ট ট্রান্সপ্ল্যান্টের প্রয়োজন আছে কি?",
    "1237": "এটি কি পুনরায় অস্ত্রোপচার (রি-ডু)?",
    "1238": "এটি কি ভালভ মেরামত/প্রতিস্থাপন?",
    "1239": "এই শিশুটি কি পূর্বে জিএফ দ্বারা সহায়তা পেয়েছে?",
    "1240": "সুবিধাভোগীর সংক্ষিপ্ত চিকিৎসা বিবরণ",
    "1241": "অস্ত্রোপচারের আনুমানিক খরচ",
    "1242": "পরিবারের আনুমানিক অবদান",
    "1243": "হাসপাতালের আনুমানিক ছাড়",
    "1244": "পারিবারিক অবদানের উৎস",
    "1245": "হাসপাতাল চ্যারিটি সেলের আনুমানিক অবদান",
    "1246": "অন্যান্য অবদানের পরিমাণ",
    "1247": "হাসপাতাল চ্যারিটি সেল - মন্তব্য",
    "1248": "অন্যান্য অবদান - মন্তব্য",
    "1249": "অন্যান্য অবদান - ফাইলসমূহ",
    "1250": "জিএফ-এর সর্বাধিক অবদান",
    "1251": "হাসপাতালের নাম",
    "1252": "চিকিৎসাকারী ডাক্তার",
    "1253": "আমাকে সম্মতি ফর্ম, আবেদন ফর্ম এবং ঘোষণা ফর্মের একটি কপি দেওয়া হয়েছে",
    "1254": "উপরে দেওয়া তথ্য সত্য এবং সম্পূর্ণ",
    "1255": "উপরে বর্ণিত আমার সন্তানের (সুবিধাভোগী) চিকিৎসার ব্যয় বহন করতে আমি অক্ষম",
    "1263": "আমি স্বীকার করছি যে শিশুটির চিকিৎসার জন্য আর্থিক ও অন্যান্য সহায়তা একটি বিনামূল্যে ও পরোপকারী ভাবনায় প্রদান করা হচ্ছে। আমি নিশ্চিত করছি যে জেনেসিস ফাউন্ডেশন, এর ট্রাস্টি, কর্মকর্তা, কর্মচারী ও স্বেচ্ছাসেবকরা আমার সন্তানের চিকিৎসার জন্য কোনো দায়বদ্ধ নন। আমি এতদ্বারা চিকিৎসা সংক্রান্ত যেকোনো দাবি পরিত্যাগ করছি।",
    "1257": "পিতামাতা/অভিভাবক কি উপরের সকল ঘোষণায় সম্মত?",
    "1258": "আবেদন ফর্ম পূরণকারী",
    "1259": "পদবি",
    "1260": "জন্ম শংসাপত্র নথিপত্র",
    "1261": "অস্ত্রোপচারপূর্ব সুবিধাভোগীর ছবি",
    "1264": "আমি নিশ্চিত করছি যে একটি বৈধ জন্ম শংসাপত্র জমা দেওয়া হয়েছে। অতএব, সুবিধাভোগীর যাচাইকরণ বিবরণের প্রয়োজন নেই এবং যাচাই বিভাগ এড়িয়ে যাওয়া যেতে পারে।",
    "1265": "সুবিধাভোগীর নাম",
    "1266": "সুবিধাভোগীর লিঙ্গ",
    "1267": "সুবিধাভোগীর পরিচয়পত্র প্রমাণ যাচাইকরণ",
    "1269": "সুবিধাভোগীর মায়ের নাম",
    "1270": "মায়ের আধার ও ভোটার আইডি যাচাই",
    "1271": "মায়ের ভোটার আইডি যাচাইকরণ",
    "1272": "সুবিধাভোগীর বাবার নাম",
    "1273": "বাবার আধার ও ভোটার আইডি যাচাই",
    "1274": "বাবার ভোটার আইডি যাচাইকরণ",
    "1275": "উপার্জনকারী পরিবারের সদস্যের নাম",
    "1276": "মাসিক আয়",
    "1277": "বার্ষিক আয়",
    "1278": "জমাকৃত আয়ের প্রমাণের ভাষা",
    "1279": "হাসপাতাল প্রতিনিধির নাম",
    "1280": "হাসপাতাল প্রতিনিধির পদ",
    "1281": "আমি, {name}, পদবী {designation}, উপরে উল্লিখিত প্রতিটি আধার কার্ড/ভোটার আইডি এবং আয় সংক্রান্ত প্রমাণপত্র (স্থানীয় ভাষায় থাকা প্রমাণপত্র সহ) দেখেছি এবং নিশ্চিত করছি যে বিবরণগুলি আবেদনপত্রে দেওয়া বিবরণের সাথে মিলে যাচ্ছে।",
    "1285": "উচ্চ শিক্ষার যোগ্যতা",
    "1286": "মায়ের পরিচয়পত্রের ধরন",
    "1287": "বাবার পরিচয়পত্রের ধরন",
    "1288": "অভিভাবকের পরিচয়পত্রের ধরন",
    "1289": "মায়ের আধার কার্ড নম্বর",
    "1290": "মায়ের ভোটার কার্ড নম্বর",
    "1291": "বাবার আধার কার্ড নম্বর",
    "1292": "বাবার ভোটার কার্ড নম্বর",
    "1293": "অভিভাবকের আধার কার্ড নম্বর",
    "1294": "অভিভাবকের ভোটার কার্ড নম্বর",
    "1295": "অভিভাবকের সম্পর্ক",
    "1296": "জন্মগত হৃদরোগের মামলা - মন্তব্য - অনুগ্রহ করে উল্লেখ করুন",
    "1297": "ইকো রিপোর্ট নথিপত্র",
    "1298": "অনুমান পত্র নথিপত্র",
    "1299": "আয়ের প্রমাণ নথিপত্র",
    "1300": "পারিবারিক ছবি",
    "1301": "অভিভাবকের আধার ও ভোটার আইডি যাচাই",
  },

  Odia: {
    "1128": "ସମ୍ମତି ଭାଷା",
    "1132": "ସମ୍ମତି ଦସ୍ତଖତ ଅଂଶ",
    "1131": "କାର୍ଯ୍ୟ ପ୍ରକାର",
    "1133": "ଯାହା ପାଇଁ ସମ୍ମତି ସ୍ୱାକ୍ଷରିତ",
    "1134": "ସମ୍ମତି ସ୍ୱାକ୍ଷରକାରୀ",
    "1135": "ସମ୍ମତି ସଂଲଗ୍ନକ",
    "1136": "ପ୍ରତ୍ୟାହାର କାରଣ",
    "1137": "ତାରିଖ",
    "1138": "ପ୍ରତ୍ୟାହାର କାର୍ଯ୍ୟକାରୀ ତାରିଖ",
    "1282": "ଯାହା ପାଇଁ ସମ୍ମତି ସ୍ୱାକ୍ଷରିତ ନୁହେଁ",
    "1283": "ଅଭିଭାବକଙ୍କ ନାମ",
    "1284": "ଅଭିଭାବକଙ୍କ ସମ୍ପର୍କ",
    "1139": "ସମ୍ମତିର ଚୂଡ଼ାନ୍ତ ସ୍ଥିତି",
    "1140": "ମାମଲା ପ୍ରାପ୍ତ ତାରିଖ",
    "1141": "ମାମଲାର ଉତ୍ସ",
    "1142": "ଅନ୍ୟ ହୋଇଥିଲେ, ଦୟାକରି ଉଲ୍ଲେଖ କରନ୍ତୁ",
    "1143": "GF ସହାୟତାପ୍ରାପ୍ତ ସ୍କ୍ରୀନିଂ ଶିବିର",
    "1144": "ସ୍କ୍ରୀନିଂ ଶିବିର ଡାକ୍ତରଖାନା ସ୍ଥାନ",
    "1145": "ଆଉଟ୍ ରିଚ୍ OPD ସ୍ଥାନ",
    "1146": "ରେଫରରୁ ଆସିଥିବା ଡାକ୍ତରଖାନାର ନାମ",
    "1147": "ରେଫରରୁ ଆସିଥିବା ଡାକ୍ତରଖାନାର ସ୍ଥାନ",
    "1148": "ସୁବିଧାଭୋଗୀଙ୍କ ସମ୍ପୂର୍ଣ୍ଣ ନାମ",
    "1149": "ଉପନାମ / ଡାକ ନାମ",
    "1150": "ବୟସ ମୂଲ୍ୟ",
    "1151": "ବୟସ ଏକକ (ଦିନ/ମାସ/ବର୍ଷରେ)",
    "1152": "ବୟସ ଶ୍ରେଣୀ",
    "1153": "ଲିଙ୍ଗ",
    "1154": "ଧର୍ମ",
    "1155": "ଶରୀର ଓଜନ (କି.ଗ୍ରା.)",
    "1156": "ଶିକ୍ଷା ଅବସ୍ଥା",
    "1157": "ବିଦ୍ୟାଳୟ/ମହାବିଦ୍ୟାଳୟର ନାମ",
    "1158": "ସୁବିଧାଭୋଗୀଙ୍କ ପରିଚୟପତ୍ର ପ୍ରମାଣ",
    "1159": "ଆଧାର କାର୍ଡ ନମ୍ବର",
    "1160": "ଡାକ୍ତରଖାନା ଦ୍ୱାରା ଆଧାର କାର୍ଡ ଯାଞ୍ଚ ହୋଇଛି?",
    "1161": "ଜନ୍ମ ପ୍ରମାଣପତ୍ର GF ସହ ଅଂଶୀଦାର",
    "1162": "ଯାଞ୍ଚ ଫର୍ମ ଡାକ୍ତରଖାନା ଦ୍ୱାରା ପୂରଣ ଏବଂ ସ୍ୱାକ୍ଷରିତ",
    "1163": "ପିତାମାତାଙ୍କ ସ୍ଥିତି",
    "1164": "ଶିଶୁ କାହା ସହିତ ରହୁଛି",
    "1165": "ମାଆଙ୍କ ନାମ",
    "1166": "ମାଆଙ୍କ ବୟସ",
    "1167": "ମାଆଙ୍କ ବୃତ୍ତି",
    "1168": "ମାଆଙ୍କ ମାସିକ ଆୟ",
    "1169": "ବାପାଙ୍କ ନାମ",
    "1170": "ବାପାଙ୍କ ବୟସ",
    "1171": "ବାପାଙ୍କ ବୃତ୍ତି",
    "1172": "ବାପାଙ୍କ ମାସିକ ଆୟ",
    "1173": "ଅଭିଭାବକଙ୍କ ନାମ",
    "1174": "ଅଭିଭାବକଙ୍କ ବୟସ",
    "1175": "ଅଭିଭାବକଙ୍କ ବୃତ୍ତି",
    "1176": "ଅଭିଭାବକଙ୍କ ମାସିକ ଆୟ",
    "1177": "ପରିବାରର ମୋଟ ଆୟ",
    "1178": "ଠିକଣା ଉତ୍ସ",
    "1179": "ସମ୍ପୂର୍ଣ ଠିକଣା",
    "1180": "ପ୍ରାଥମିକ ଯୋଗାଯୋଗ ବ୍ୟକ୍ତି",
    "1181": "ପ୍ରାଥମିକ ଯୋଗାଯୋଗ ନମ୍ବର",
    "1182": "ବିକଳ୍ପ ଯୋଗାଯୋଗ ନମ୍ବର",
    "1183": "ସୁବିଧାଭୋଗୀଙ୍କ ଭାଇ-ଭଉଣୀ ସଂଖ୍ୟା",
    "1184": "ସୁବିଧାଭୋଗୀଙ୍କ ସ୍ଥାୟୀ ଠିକଣା",
    "1185": "ରାଜ୍ୟ",
    "1186": "ପିତାମାତା/ଅଭିଭାବକ ଅଞ୍ଚଳ",
    "1206": "ଜିଲ୍ଲା",
    "1207": "ଏହା ଏକ ଆକାଂକ୍ଷୀ ଜିଲ୍ଲା କି?",
    "1208": "ଗ୍ରାମ/ଅଞ୍ଚଳର ନାମ",
    "1209": "ଭୌଗୋଳିକ ବର୍ଗୀକରଣ",
    "1210": "ଆଦିବାସୀ ଅଞ୍ଚଳ",
    "1211": "ଏହା ଏକ ଜନ୍ମଗତ ହୃଦୟ ରୋଗ ମାମଲା କି?",
    "1212": "ଅପରେସନ ପୂର୍ବ ଲକ୍ଷଣ",
    "1213": "ମାମଲା ପ୍ରକାର",
    "1229": "ରୋଗ ନିର୍ଣ୍ଣୟ",
    "1230": "ନିର୍ଦ୍ଧାରିତ ଚିକିତ୍ସା",
    "1231": "ଅସ୍ତ୍ରୋପଚାରର ପ୍ରକାର",
    "1232": "ଏହା ଏକ ଭିଏସଡି ଡିଭାଇସ କ୍ଲୋଜର କି?",
    "1233": "ଏହା ଏକ ସିଙ୍ଗଲ ଭେଣ୍ଟ୍ରିକଲ ଫିଜିଓଲୋଜି କି?",
    "1234": "ଏହା ଏକ ହାଇପୋପ୍ଲାଷ୍ଟିକ ହାର୍ଟ କି?",
    "1235": "ଡାଉନ ସିଣ୍ଡ୍ରୋମ କିମ୍ବା ଅନ୍ୟାନ୍ୟ ପ୍ରମୁଖ ଜେନେଟିକ ସ୍ଥିତି ସହିତ ସିଏଚଡି ମାମଲା କି?",
    "1236": "ହୃଦୟ ପ୍ରତିରୋପଣ ଆବଶ୍ୟକ କି?",
    "1237": "ଏହା ଏକ ପୁନଃ ଅସ୍ତ୍ରୋପଚାର (ରି-ଡୁ) କି?",
    "1238": "ଏହା ଏକ ଭଲଭ ମରାମତି/ପ୍ରତିସ୍ଥାପନ କି?",
    "1239": "ଏହି ଶିଶୁଟି ପୂର୍ବରୁ ଜିଏଫ ଦ୍ୱାରା ସହାୟତା ପାଇଛି କି?",
    "1240": "ସୁବିଧାଭୋଗୀଙ୍କ ସଂକ୍ଷିପ୍ତ ଚିକିତ୍ସା ବିବରଣୀ",
    "1241": "ଅସ୍ତ୍ରୋପଚାରର ଆନୁମାନିକ ଖର୍ଚ",
    "1242": "ପରିବାରର ଆନୁମାନିକ ଅବଦାନ",
    "1243": "ଡାକ୍ତରଖାନା ଦ୍ୱାରା ଆନୁମାନିକ ରିହାତି",
    "1244": "ପାରିବାରିକ ଅବଦାନର ଉତ୍ସ",
    "1245": "ଡାକ୍ତରଖାନା ଚାରିଟି ସେଲର ଆନୁମାନିକ ଅବଦାନ",
    "1246": "ଅନ୍ୟ ଅବଦାନ ପରିମାଣ",
    "1247": "ଡାକ୍ତରଖାନା ଚ୍ୟାରିଟି ସେଲ - ମନ୍ତବ୍ୟ",
    "1248": "ଅନ୍ୟ ଅବଦାନ - ମନ୍ତବ୍ୟ",
    "1249": "ଅନ୍ୟ ଅବଦାନ - ଫାଇଲ",
    "1250": "ଜିଏଫର ସର୍ବାଧିକ ଅବଦାନ",
    "1251": "ଡାକ୍ତରଖାନା ନାମ",
    "1252": "ଚିକିତ୍ସାକାରୀ ଡାକ୍ତର",
    "1253": "ମୋତେ ସମ୍ମତି ଫର୍ମ, ଆବେଦନ ଫର୍ମ ଏବଂ ଘୋଷଣା ଫର୍ମର ଏକ ନକଲ ଦିଆ ହୋଇଛି",
    "1254": "ଉପର ଦିଆ ସୂଚନା ସତ୍ୟ ଓ ସମ୍ପୂର୍ଣ",
    "1255": "ଉପରେ ବର୍ଣ୍ଣିତ ମୋ ପିଲାର (ସୁବିଧାଭୋଗୀ) ଚିକିତ୍ସା ଖର୍ଚ୍ଚ ବହନ କରିବାକୁ ମୁଁ ସକ୍ଷମ ନୁହେଁ",
    "1263": "ମୁଁ ସ୍ୱୀକାର କରୁଛି ଯେ ଶିଶୁর ଚିକିତ୍ସା ପାଇଁ ଆର୍ଥିକ ଓ ଅନ୍ୟ ସହାୟତା ଏକ ଦୟାଳୁ ଓ ପରୋପକାରୀ ଭାବନାରୁ ପ୍ରଦାନ କରାଯାଉଛି। ଜେନେସିସ ଫାଉଣ୍ଡେସନ, ଏହାର ଟ୍ରଷ୍ଟି, ଅଧିକାରୀ, କର୍ମଚାରୀ ଓ ସ୍ୱେଚ୍ଛାସେବୀମାନେ ଚିକିତ୍ସା ସଂକ୍ରାନ୍ତ କୌଣସି ଦାୟିତ୍ୱ ବହନ କରିବେ ନାହିଁ। ମୁଁ ଏଥିସହ ଚିକିତ୍ସା ସଂକ୍ରାନ୍ତ ସମସ୍ତ ଦାବୀ ଛାଡ଼ୁଛି।",
    "1257": "ପିତାମାତା/ଅଭିଭାବକ ଉପରୋକ୍ତ ସମସ୍ତ ଘୋଷଣାରେ ସହମତ କି?",
    "1258": "ଆବେଦନ ଫର୍ମ ପୂରଣ କରିଥିବା ବ୍ୟକ୍ତି",
    "1259": "ପଦବୀ",
    "1260": "ଜନ୍ମ ପ୍ରମାଣପତ୍ର ଡକ୍ୟୁମେଣ୍ଟ",
    "1261": "ଅପରେଶନ ପୂର୍ବ ସୁବିଧାଭୋଗୀ ଫଟୋ",
    "1264": "ମୁଁ ନିଶ୍ଚିତ କରୁଛି ଯେ ଏକ ବୈଧ ଜନ୍ମ ସାର୍ଟିଫିକେଟ ଦାଖଲ ହୋଇଛି। ତେଣୁ, ସୁବିଧାଭୋଗୀଙ୍କ ଯାଞ୍ଚ ବିବରଣ ଆବଶ୍ୟକ ନୁହେଁ ଓ ଯାଞ୍ଚ ଅଂଶ ଛାଡ଼ି ଦିଆ ଯାଇ ପାରିବ।",
    "1265": "ସୁବିଧାଭୋଗୀଙ୍କ ନାମ",
    "1266": "ସୁବିଧାଭୋଗୀଙ୍କ ଲିଙ୍ଗ",
    "1267": "ସୁବିଧାଭୋଗୀଙ୍କ ପରିଚୟପତ୍ର ପ୍ରମାଣ ଯାଞ୍ଚ",
    "1269": "ସୁବିଧାଭୋଗୀଙ୍କ ମାଆଙ୍କ ନାମ",
    "1270": "ମାଆଙ୍କ ଆଧାର ଓ ଭୋଟର ଆଇଡ଼ି ଯାଞ୍ଚ",
    "1271": "ମାଆଙ୍କ ଭୋଟର ଆଇଡ଼ି ଯାଞ୍ଚ",
    "1272": "ସୁବିଧାଭୋଗୀଙ୍କ ବାପାଙ୍କ ନାମ",
    "1273": "ବାପାଙ୍କ ଆଧାର ଓ ଭୋଟର ଆଇଡ଼ି ଯାଞ୍ଚ",
    "1274": "ବାପାଙ୍କ ଭୋଟର ଆଇଡ଼ି ଯାଞ୍ଚ",
    "1275": "ଉପାର୍ଜନକାରୀ ପରିବାର ସଦସ୍ୟଙ୍କ ନାମ",
    "1276": "ମାସିକ ଆୟ",
    "1277": "ବାର୍ଷିକ ଆୟ",
    "1278": "ଦାଖଲ ହୋଇଥିବା ଆୟ ପ୍ରମାଣର ଭାଷା",
    "1279": "ଡାକ୍ତରଖାନା ପ୍ରତିନିଧିଙ୍କ ନାମ",
    "1280": "ଡାକ୍ତରଖାନା ପ୍ରତିନିଧିଙ୍କ ପଦ",
    "1281": "ମୁଁ, {name}, ପଦବୀ {designation}, ଉପରେ ଉଲ୍ଲେଖ କରାଯାଇଥିବା ପ୍ରତ୍ୟେକ ଆଧାର କାର୍ଡ/ଭୋଟର ଆଇଡ଼ି ଏବଂ ଆୟ ପ୍ରମାଣପତ୍ର (ସ୍ଥାନୀୟ ଭାଷାରେ ଥିବା ପ୍ରମାଣପତ୍ର ସହିତ) ଦେଖିଛି ଏବଂ ଏହି ବିବରଣୀଗୁଡ଼ିକ ଆବେଦନ ପତ୍ରରେ ଥିବା ବିବରଣୀ ସହ ମେଲ ଖାଉଛି ବୋଲି ନିଶ୍ଚିତ କରୁଛି।",
    "1285": "ଉଚ୍ଚ ଶିକ୍ଷା ଯୋଗ୍ୟତା",
    "1286": "ମାଆଙ୍କ ପ୍ରମାଣ ପ୍ରକାର",
    "1287": "ବାପାଙ୍କ ପ୍ରମାଣ ପ୍ରକାର",
    "1288": "ଅଭିଭାବକଙ୍କ ପ୍ରମାଣ ପ୍ରକାର",
    "1289": "ମାଆଙ୍କ ଆଧାର ନଂ.",
    "1290": "ମାଆଙ୍କ ଭୋଟର ଆଇଡ଼ି ନଂ.",
    "1291": "ବାପାଙ୍କ ଆଧାର ନଂ.",
    "1292": "ବାପାଙ୍କ ଭୋଟର ଆଇଡ଼ି ନଂ.",
    "1293": "ଅଭିଭାବକଙ୍କ ଆଧାର ନଂ.",
    "1294": "ଅଭିଭାବକଙ୍କ ଭୋଟର ଆଇଡ଼ି ନଂ.",
    "1295": "ଅଭିଭାବକଙ୍କ ସମ୍ପର୍କ",
    "1296": "ଜନ୍ମଗତ ହୃଦୟ ରୋଗ ମାମଲା - ମନ୍ତବ୍ୟ - ଦୟାକରି ଉଲ୍ଲେଖ କରନ୍ତୁ",
    "1297": "ଇକୋ ରିପୋର୍ଟ ଡକ୍ୟୁମେଣ୍ଟ",
    "1298": "ଅନୁମାନ ପତ୍ର ଡକ୍ୟୁମେଣ୍ଟ",
    "1299": "ଆୟ ପ୍ରମାଣ ଡକ୍ୟୁମେଣ୍ଟ",
    "1300": "ପରିବାର ଫଟୋ",
    "1301": "ଅଭିଭାବକଙ୍କ ଆଧାର ଓ ଭୋଟର ଆଇଡ଼ି ଯାଞ୍ଚ",
  },

  Hindi: {
    "1128": "सहमति भाषा",
    "1132": "सहमति हस्ताक्षरित अनुभाग",
    "1131": "कार्रवाई का प्रकार",
    "1133": "जिसके लिए सहमति हस्ताक्षरित",
    "1134": "सहमति हस्ताक्षरकर्ता",
    "1135": "सहमति संलग्नक",
    "1136": "निरस्तीकरण का कारण",
    "1137": "दिनांक",
    "1138": "निरस्तीकरण प्रभावी तिथि",
    "1282": "जिसके लिए सहमति हस्ताक्षरित नहीं है",
    "1283": "अभिभावक का नाम",
    "1284": "अभिभावक का संबंध",
    "1139": "सहमति अंतिम स्थिति",
    "1140": "मामला प्राप्त तिथि",
    "1141": "मामले का स्रोत",
    "1142": "यदि अन्य, कृपया निर्दिष्ट करें",
    "1143": "GF समर्थित जांच शिविर",
    "1144": "जांच शिविर अस्पताल स्थान",
    "1145": "आउटरीच ओपीडी स्थान",
    "1146": "संदर्भित अस्पताल का नाम",
    "1147": "संदर्भित अस्पताल का स्थान",
    "1148": "लाभार्थी का पूरा नाम",
    "1149": "उपनाम / अन्य नाम",
    "1150": "आयु मूल्य",
    "1151": "आयु इकाई (दिन/माह/वर्ष में)",
    "1152": "आयु श्रेणी",
    "1153": "लिंग",
    "1154": "धर्म",
    "1155": "शरीर का वजन (किग्रा)",
    "1156": "शिक्षा स्थिति",
    "1157": "स्कूल/कॉलेज का नाम",
    "1158": "लाभार्थी पहचान प्रमाण",
    "1159": "आधार कार्ड नंबर",
    "1160": "अस्पताल द्वारा आधार कार्ड सत्यापित?",
    "1161": "जन्म प्रमाणपत्र GF के साथ साझा",
    "1162": "सत्यापन फॉर्म अस्पताल द्वारा भरा एवं हस्ताक्षरित",
    "1163": "माता-पिता की स्थिति",
    "1164": "बच्चा किसके साथ रह रहा है",
    "1165": "माँ का नाम",
    "1166": "माँ की आयु",
    "1167": "माँ का व्यवसाय",
    "1168": "माँ की मासिक आय",
    "1169": "पिता का नाम",
    "1170": "पिता की आयु",
    "1171": "पिता का व्यवसाय",
    "1172": "पिता की मासिक आय",
    "1173": "अभिभावक का नाम",
    "1174": "अभिभावक की आयु",
    "1175": "अभिभावक का व्यवसाय",
    "1176": "अभिभावक की मासिक आय",
    "1177": "कुल पारिवारिक आय",
    "1178": "पता स्रोत",
    "1179": "पूरा पता",
    "1180": "प्राथमिक संपर्क व्यक्ति",
    "1181": "प्राथमिक संपर्क नंबर",
    "1182": "वैकल्पिक संपर्क नंबर",
    "1183": "लाभार्थी के भाई-बहनों की संख्या",
    "1184": "लाभार्थी का स्थायी पता",
    "1185": "राज्य",
    "1186": "माता-पिता/अभिभावक क्षेत्र",
    "1206": "जिला",
    "1207": "क्या यह आकांक्षी जिला है?",
    "1208": "गाँव/क्षेत्र का नाम",
    "1209": "भौगोलिक वर्गीकरण",
    "1210": "जनजातीय क्षेत्र",
    "1211": "क्या जन्मजात हृदय दोष का मामला है?",
    "1212": "सर्जरी से पहले के लक्षण",
    "1213": "मामले का प्रकार",
    "1229": "निदान",
    "1230": "निर्धारित उपचार",
    "1231": "सर्जरी का प्रकार",
    "1232": "क्या वीएसडी डिवाइस क्लोजर है?",
    "1233": "क्या सिंगल वेंट्रिकल फिजियोलॉजी है?",
    "1234": "क्या हाइपोप्लास्टिक हार्ट है?",
    "1235": "क्या डाउन सिंड्रोम या अन्य प्रमुख आनुवंशिक स्थिति के साथ सीएचडी मामला है?",
    "1236": "क्या हृदय प्रत्यारोपण की आवश्यकता है?",
    "1237": "क्या दोबारा सर्जरी (री-डू) है?",
    "1238": "क्या वाल्व मरम्मत/प्रतिस्थापन है?",
    "1239": "क्या इस बच्चे को पहले जीएफ द्वारा सहायता दी गई है?",
    "1240": "लाभार्थी का संक्षिप्त चिकित्सा विवरण",
    "1241": "सर्जरी की अनुमानित लागत",
    "1242": "परिवार का अनुमानित योगदान",
    "1243": "अस्पताल द्वारा अनुमानित छूट",
    "1244": "पारिवारिक योगदान का स्रोत",
    "1245": "अस्पताल चैरिटी सेल का अनुमानित योगदान",
    "1246": "अन्य योगदान राशि",
    "1247": "अस्पताल चैरिटी सेल - टिप्पणी",
    "1248": "अन्य योगदान - टिप्पणी",
    "1249": "अन्य योगदान - फ़ाइलें",
    "1250": "जीएफ का अधिकतम योगदान",
    "1251": "अस्पताल का नाम",
    "1252": "उपचार करने वाले डॉक्टर",
    "1253": "मुझे सहमति फॉर्म, आवेदन फॉर्म और घोषणा फॉर्म की एक प्रति प्रदान की गई है",
    "1254": "ऊपर दी गई जानकारी सत्य और पूर्ण है",
    "1255": "मैं ऊपर वर्णित अपने बच्चे (लाभार्थी) के उपचार का खर्च वहन करने में असमर्थ हूँ",
    "1263": "मैं स्वीकार करता/करती हूँ कि बच्चे के उपचार के लिए वित्तीय और अन्य सहायता एक निःशुल्क और परोपकारी भावना से प्रदान की जा रही है। मैं पुष्टि करता/करती हूँ कि जेनेसिस फाउंडेशन, इसके ट्रस्टी, अधिकारी, कर्मचारी और स्वयंसेवक मेरे बच्चे के उपचार के संबंध में किसी भी दायित्व के लिए जिम्मेदार नहीं होंगे। मैं एतद्द्वारा उपचार से संबंधित सभी दावों का त्याग करता/करती हूँ।",
    "1257": "क्या माता-पिता/अभिभावक उपरोक्त सभी घोषणाओं से सहमत हैं?",
    "1258": "आवेदन फॉर्म भरने वाले का नाम",
    "1259": "पदनाम",
    "1260": "जन्म प्रमाणपत्र दस्तावेज़",
    "1261": "सर्जरी से पहले की लाभार्थी की फ़ोटो",
    "1264": "मैं पुष्टि करता/करती हूँ कि एक वैध जन्म प्रमाण पत्र जमा किया गया है। अतः लाभार्थी के सत्यापन विवरण की आवश्यकता नहीं है और सत्यापन अनुभाग को छोड़ा जा सकता है।",
    "1265": "लाभार्थी का नाम",
    "1266": "लाभार्थी का लिंग",
    "1267": "लाभार्थी पहचान प्रमाण सत्यापन",
    "1269": "लाभार्थी की माँ का नाम",
    "1270": "माँ का आधार और मतदाता पहचान पत्र सत्यापन",
    "1271": "माँ का वोटर आईडी सत्यापन",
    "1272": "लाभार्थी के पिता का नाम",
    "1273": "पिता का आधार और मतदाता पहचान पत्र सत्यापन",
    "1274": "पिता का वोटर आईडी सत्यापन",
    "1275": "कमाने वाले परिवार के सदस्य का नाम",
    "1276": "मासिक आय",
    "1277": "वार्षिक आय",
    "1278": "जमा किए गए आय प्रमाण की भाषा",
    "1279": "अस्पताल प्रतिनिधि का नाम",
    "1280": "अस्पताल प्रतिनिधि का पदनाम",
    "1281": "मैं, {name}, पद {designation}, ऊपर उल्लिखित प्रत्येक आधार कार्ड/मतदाता पहचान पत्र और आय प्रमाण (कच्ची/स्थानीय भाषाओं सहित) को देख चुका/चुकी हूँ और यह भी सुनिश्चित करता/करती हूँ कि विवरण आवेदन पत्र में दिए गए विवरण से मेल खाते हैं।",
    "1285": "उच्च शिक्षा योग्यता",
    "1286": "माँ का पहचान प्रमाण प्रकार",
    "1287": "पिता का पहचान प्रमाण प्रकार",
    "1288": "अभिभावक का पहचान प्रमाण प्रकार",
    "1289": "माँ का आधार कार्ड नंबर",
    "1290": "माँ का मतदाता कार्ड नंबर",
    "1291": "पिता का आधार कार्ड नंबर",
    "1292": "पिता का मतदाता कार्ड नंबर",
    "1293": "अभिभावक का आधार कार्ड नंबर",
    "1294": "अभिभावक का मतदाता कार्ड नंबर",
    "1295": "अभिभावक का संबंध",
    "1296": "जन्मजात हृदय रोग मामला - टिप्पणी - कृपया निर्दिष्ट करें",
    "1297": "इको रिपोर्ट दस्तावेज़",
    "1298": "अनुमान पत्र दस्तावेज़",
    "1299": "आय प्रमाण दस्तावेज़",
    "1300": "परिवार की फ़ोटो",
    "1301": "अभिभावक का आधार और मतदाता पहचान पत्र सत्यापन",
  },

  Punjabi: {
    "1128": "ਸਹਿਮਤੀ ਭਾਸ਼ਾ",
    "1132": "ਸਹਿਮਤੀ ਦਸਤਖ਼ਤ ਭਾਗ",
    "1131": "ਕਾਰਵਾਈ ਦੀ ਕਿਸਮ",
    "1133": "ਜਿਸ ਲਈ ਸਹਿਮਤੀ ਦਸਤਖਤ ਕੀਤੀ ਗਈ",
    "1134": "ਸਹਿਮਤੀ ਦਸਤਖਤਕਰਤਾ",
    "1135": "ਸਹਿਮਤੀ ਨੱਥੀ",
    "1136": "ਰੱਦ ਕਰਨ ਦਾ ਕਾਰਨ",
    "1137": "ਮਿਤੀ",
    "1138": "ਰੱਦ ਹੋਣ ਦੀ ਲਾਗੂ ਮਿਤੀ",
    "1282": "ਜਿਸ ਲਈ ਸਹਿਮਤੀ ਦਸਤਖਤ ਨਹੀਂ ਕੀਤੀ ਗਈ",
    "1283": "ਸਰਪ੍ਰਸਤ ਦਾ ਨਾਮ",
    "1284": "ਸਰਪ੍ਰਸਤ ਦਾ ਸੰਬੰਧ",
    "1139": "ਸਹਿਮਤੀ ਅੰਤਿਮ ਸਥਿਤੀ",
    "1140": "ਕੇਸ ਪ੍ਰਾਪਤੀ ਮਿਤੀ",
    "1141": "ਕੇਸ ਦਾ ਸਰੋਤ",
    "1142": "ਜੇ ਹੋਰ, ਕਿਰਪਾ ਕਰਕੇ ਦੱਸੋ",
    "1143": "GF ਸਮਰਥਿਤ ਸਕ੍ਰੀਨਿੰਗ ਕੈਂਪ",
    "1144": "ਸਕ੍ਰੀਨਿੰਗ ਕੈਂਪ ਹਸਪਤਾਲ ਸਥਾਨ",
    "1145": "ਆਊਟਰੀਚ OPD ਸਥਾਨ",
    "1146": "ਭੇਜੇ ਗਏ ਹਸਪਤਾਲ ਦਾ ਨਾਮ",
    "1147": "ਭੇਜੇ ਗਏ ਹਸਪਤਾਲ ਦਾ ਸਥਾਨ",
    "1148": "ਲਾਭਪਾਤਰੀ ਦਾ ਪੂਰਾ ਨਾਮ",
    "1149": "ਉਪਨਾਮ / ਹੋਰ ਨਾਮ",
    "1150": "ਉਮਰ ਮੁੱਲ",
    "1151": "ਉਮਰ ਦੀ ਇਕਾਈ (ਦਿਨ/ਮਹੀਨੇ/ਸਾਲਾਂ ਵਿੱਚ)",
    "1152": "ਉਮਰ ਸ਼੍ਰੇਣੀ",
    "1153": "ਲਿੰਗ",
    "1154": "ਧਰਮ",
    "1155": "ਸਰੀਰ ਦਾ ਭਾਰ (ਕਿਲੋਗ੍ਰਾਮ)",
    "1156": "ਸਿੱਖਿਆ ਸਥਿਤੀ",
    "1157": "ਸਕੂਲ/ਕਾਲਜ ਦਾ ਨਾਮ",
    "1158": "ਲਾਭਪਾਤਰੀ ਪਛਾਣ ਪ੍ਰਮਾਣ",
    "1159": "ਆਧਾਰ ਕਾਰਡ ਨੰਬਰ",
    "1160": "ਹਸਪਤਾਲ ਦੁਆਰਾ ਆਧਾਰ ਕਾਰਡ ਪ੍ਰਮਾਣਿਤ?",
    "1161": "ਜਨਮ ਸਰਟੀਫਿਕੇਟ GF ਨਾਲ ਸਾਂਝਾ",
    "1162": "ਤਸਦੀਕ ਫਾਰਮ ਹਸਪਤਾਲ ਦੁਆਰਾ ਭਰਿਆ ਅਤੇ ਦਸਤਖਤ ਕੀਤਾ ਗਿਆ",
    "1163": "ਮਾਤਾ-ਪਿਤਾ ਦੀ ਸਥਿਤੀ",
    "1164": "ਬੱਚਾ ਕਿਸ ਨਾਲ ਰਹਿ ਰਿਹਾ ਹੈ",
    "1165": "ਮਾਂ ਦਾ ਨਾਮ",
    "1166": "ਮਾਂ ਦੀ ਉਮਰ",
    "1167": "ਮਾਂ ਦਾ ਪੇਸ਼ਾ",
    "1168": "ਮਾਂ ਦੀ ਮਹੀਨਾਵਾਰ ਆਮਦਨ",
    "1169": "ਪਿਤਾ ਦਾ ਨਾਮ",
    "1170": "ਪਿਤਾ ਦੀ ਉਮਰ",
    "1171": "ਪਿਤਾ ਦਾ ਪੇਸ਼ਾ",
    "1172": "ਪਿਤਾ ਦੀ ਮਹੀਨਾਵਾਰ ਆਮਦਨ",
    "1173": "ਸਰਪ੍ਰਸਤ ਦਾ ਨਾਮ",
    "1174": "ਸਰਪ੍ਰਸਤ ਦੀ ਉਮਰ",
    "1175": "ਸਰਪ੍ਰਸਤ ਦਾ ਪੇਸ਼ਾ",
    "1176": "ਸਰਪ੍ਰਸਤ ਦੀ ਮਹੀਨਾਵਾਰ ਆਮਦਨ",
    "1177": "ਪਰਿਵਾਰ ਦੀ ਕੁੱਲ ਆਮਦਨ",
    "1178": "ਪਤੇ ਦਾ ਸਰੋਤ",
    "1179": "ਪੂਰਾ ਪਤਾ",
    "1180": "ਮੁੱਖ ਸੰਪਰਕ ਵਿਅਕਤੀ",
    "1181": "ਮੁੱਖ ਸੰਪਰਕ ਨੰਬਰ",
    "1182": "ਵਿਕਲਪਿਕ ਸੰਪਰਕ ਨੰਬਰ",
    "1183": "ਲਾਭਪਾਤਰੀ ਦੇ ਭੈਣ-ਭਰਾ ਦੀ ਗਿਣਤੀ",
    "1184": "ਲਾਭਪਾਤਰੀ ਦਾ ਸਥਾਈ ਪਤਾ",
    "1185": "ਰਾਜ",
    "1186": "ਮਾਤਾ-ਪਿਤਾ/ਸਰਪ੍ਰਸਤ ਖੇਤਰ",
    "1206": "ਜ਼ਿਲ੍ਹਾ",
    "1207": "ਕੀ ਇਹ ਅਕਾਂਖੀ ਜ਼ਿਲ੍ਹਾ ਹੈ?",
    "1208": "ਪਿੰਡ/ਇਲਾਕੇ ਦਾ ਨਾਮ",
    "1209": "ਭੂਗੋਲਿਕ ਵਰਗੀਕਰਨ",
    "1210": "ਕਬਾਇਲੀ ਖੇਤਰ",
    "1211": "ਕੀ ਜਮਾਂਦਰੂ ਦਿਲ ਦੇ ਨੁਕਸ ਦਾ ਮਾਮਲਾ ਹੈ?",
    "1212": "ਸਰਜਰੀ ਤੋਂ ਪਹਿਲਾਂ ਦੇ ਲੱਛਣ",
    "1213": "ਕੇਸ ਦੀ ਕਿਸਮ",
    "1229": "ਨਿਦਾਨ",
    "1230": "ਨਿਰਧਾਰਿਤ ਇਲਾਜ",
    "1231": "ਸਰਜਰੀ ਦੀ ਕਿਸਮ",
    "1232": "ਕੀ ਇਹ ਵੀਐਸਡੀ ਡਿਵਾਈਸ ਕਲੋਜ਼ਰ ਹੈ?",
    "1233": "ਕੀ ਸਿੰਗਲ ਵੈਂਟ੍ਰਿਕਲ ਫਿਜ਼ੀਓਲੋਜੀ ਹੈ?",
    "1234": "ਕੀ ਹਾਈਪੋਪਲਾਸਟਿਕ ਦਿਲ ਹੈ?",
    "1235": "ਕੀ ਡਾਊਨ ਸਿੰਡਰੋਮ ਜਾਂ ਹੋਰ ਵੱਡੀ ਜੈਨੇਟਿਕ ਸਥਿਤੀ ਨਾਲ ਸੀਐਚਡੀ ਕੇਸ ਹੈ?",
    "1236": "ਕੀ ਦਿਲ ਦੇ ਟ੍ਰਾਂਸਪਲਾਂਟ ਦੀ ਲੋੜ ਹੈ?",
    "1237": "ਕੀ ਦੁਬਾਰਾ ਸਰਜਰੀ (ਰੀ-ਡੂ) ਹੈ?",
    "1238": "ਕੀ ਵਾਲਵ ਮੁਰੰਮਤ/ਬਦਲੀ ਹੈ?",
    "1239": "ਕੀ ਇਸ ਬੱਚੇ ਨੂੰ ਪਹਿਲਾਂ ਜੀਐਫ ਦੁਆਰਾ ਸਹਾਇਤਾ ਦਿੱਤੀ ਗਈ ਹੈ?",
    "1240": "ਲਾਭਪਾਤਰੀ ਦਾ ਸੰਖੇਪ ਡਾਕਟਰੀ ਵੇਰਵਾ",
    "1241": "ਆਪ੍ਰੇਸ਼ਨ ਦੀ ਅਨੁਮਾਨਿਤ ਲਾਗਤ",
    "1242": "ਪਰਿਵਾਰ ਦਾ ਅੰਦਾਜ਼ਨ ਯੋਗਦਾਨ",
    "1243": "ਹਸਪਤਾਲ ਦੁਆਰਾ ਅੰਦਾਜ਼ਨ ਛੋਟ",
    "1244": "ਪਰਿਵਾਰਕ ਯੋਗਦਾਨ ਦਾ ਸਰੋਤ",
    "1245": "ਹਸਪਤਾਲ ਚੈਰਿਟੀ ਸੈੱਲ ਦਾ ਅੰਦਾਜ਼ਨ ਯੋਗਦਾਨ",
    "1246": "ਹੋਰ ਯੋਗਦਾਨ ਰਾਸ਼ੀ",
    "1247": "ਹਸਪਤਾਲ ਚੈਰਿਟੀ ਸੈੱਲ - ਟਿੱਪਣੀ",
    "1248": "ਹੋਰ ਯੋਗਦਾਨ - ਟਿੱਪਣੀ",
    "1249": "ਹੋਰ ਯੋਗਦਾਨ - ਫਾਈਲਾਂ",
    "1250": "ਜੀਐਫ ਦਾ ਵੱਧ ਤੋਂ ਵੱਧ ਯੋਗਦਾਨ",
    "1251": "ਹਸਪਤਾਲ ਦਾ ਨਾਮ",
    "1252": "ਇਲਾਜ ਕਰਨ ਵਾਲੇ ਡਾਕਟਰ",
    "1253": "ਮੈਨੂੰ ਸਹਿਮਤੀ ਫਾਰਮ, ਅਰਜ਼ੀ ਫਾਰਮ ਅਤੇ ਘੋਸ਼ਣਾ ਫਾਰਮ ਦੀ ਕਾਪੀ ਦਿੱਤੀ ਗਈ ਹੈ",
    "1254": "ਉਪਰ ਦਿੱਤੀ ਜਾਣਕਾਰੀ ਸੱਚ ਅਤੇ ਮੁਕੰਮਲ ਹੈ",
    "1255": "ਮੈਂ ਉੱਪਰ ਦੱਸੇ ਆਪਣੇ ਬੱਚੇ (ਲਾਭਪਾਤਰੀ) ਦੇ ਇਲਾਜ ਦਾ ਖਰਚਾ ਚੁੱਕਣ ਦੇ ਸਮਰੱਥ ਨਹੀਂ ਹਾਂ",
    "1263": "ਮੈਂ ਮੰਨਦਾ/ਮੰਨਦੀ ਹਾਂ ਕਿ ਬੱਚੇ ਦੇ ਇਲਾਜ ਲਈ ਵਿੱਤੀ ਅਤੇ ਹੋਰ ਮਦਦ ਇੱਕ ਮੁਫ਼ਤ ਅਤੇ ਪਰਉਪਕਾਰੀ ਭਾਵਨਾ ਨਾਲ ਦਿੱਤੀ ਜਾ ਰਹੀ ਹੈ। ਮੈਂ ਪੁਸ਼ਟੀ ਕਰਦਾ/ਕਰਦੀ ਹਾਂ ਕਿ ਜੈਨੇਸਿਸ ਫਾਊਂਡੇਸ਼ਨ, ਇਸ ਦੇ ਟਰੱਸਟੀ, ਅਧਿਕਾਰੀ, ਕਰਮਚਾਰੀ ਅਤੇ ਵਲੰਟੀਅਰ ਮੇਰੇ ਬੱਚੇ ਦੇ ਇਲਾਜ ਸੰਬੰਧੀ ਕਿਸੇ ਵੀ ਦੇਣਦਾਰੀ ਲਈ ਜ਼ਿੰਮੇਵਾਰ ਨਹੀਂ ਹੋਣਗੇ। ਮੈਂ ਇਲਾਜ ਸੰਬੰਧੀ ਸਾਰੇ ਦਾਅਵੇ ਛੱਡਦਾ/ਛੱਡਦੀ ਹਾਂ।",
    "1257": "ਕੀ ਮਾਤਾ-ਪਿਤਾ/ਸਰਪ੍ਰਸਤ ਉਪਰੋਕਤ ਸਾਰੀਆਂ ਘੋਸ਼ਣਾਵਾਂ ਨਾਲ ਸਹਿਮਤ ਹਨ?",
    "1258": "ਅਰਜ਼ੀ ਫਾਰਮ ਭਰਨ ਵਾਲਾ",
    "1259": "ਅਹੁਦਾ",
    "1260": "ਜਨਮ ਸਰਟੀਫਿਕੇਟ ਦਸਤਾਵੇਜ਼",
    "1261": "ਸਰਜਰੀ ਤੋਂ ਪਹਿਲਾਂ ਲਾਭਪਾਤਰੀ ਦੀ ਫ਼ੋਟੋ",
    "1264": "ਮੈਂ ਪੁਸ਼ਟੀ ਕਰਦਾ/ਕਰਦੀ ਹਾਂ ਕਿ ਇੱਕ ਵੈਧ ਜਨਮ ਸਰਟੀਫਿਕੇਟ ਜਮ੍ਹਾ ਕੀਤਾ ਗਿਆ ਹੈ। ਇਸ ਲਈ ਲਾਭਪਾਤਰੀ ਦੇ ਤਸਦੀਕ ਵੇਰਵੇ ਦੀ ਲੋੜ ਨਹੀਂ ਅਤੇ ਤਸਦੀਕ ਭਾਗ ਛੱਡਿਆ ਜਾ ਸਕਦਾ ਹੈ।",
    "1265": "ਲਾਭਪਾਤਰੀ ਦਾ ਨਾਮ",
    "1266": "ਲਾਭਪਾਤਰੀ ਦਾ ਲਿੰਗ",
    "1267": "ਲਾਭਪਾਤਰੀ ਪਛਾਣ ਪੱਤਰ ਪ੍ਰਮਾਣ ਤਸਦੀਕ",
    "1269": "ਲਾਭਪਾਤਰੀ ਦੀ ਮਾਂ ਦਾ ਨਾਮ",
    "1270": "ਮਾਂ ਦੇ ਆਧਾਰ ਅਤੇ ਵੋਟਰ ਆਈਡੀ ਦੀ ਤਸਦੀਕ",
    "1271": "ਮਾਂ ਦੀ ਵੋਟਰ ਆਈਡੀ ਤਸਦੀਕ",
    "1272": "ਲਾਭਪਾਤਰੀ ਦੇ ਪਿਤਾ ਦਾ ਨਾਮ",
    "1273": "ਪਿਤਾ ਦੇ ਆਧਾਰ ਅਤੇ ਵੋਟਰ ਆਈਡੀ ਦੀ ਤਸਦੀਕ",
    "1274": "ਪਿਤਾ ਦੀ ਵੋਟਰ ਆਈਡੀ ਤਸਦੀਕ",
    "1275": "ਕਮਾਉਣ ਵਾਲੇ ਪਰਿਵਾਰ ਦੇ ਮੈਂਬਰ ਦਾ ਨਾਮ",
    "1276": "ਮਾਸਿਕ ਆਮਦਨ",
    "1277": "ਸਾਲਾਨਾ ਆਮਦਨ",
    "1278": "ਜਮ੍ਹਾ ਕੀਤੇ ਆਮਦਨ ਸਬੂਤ ਦੀ ਭਾਸ਼ਾ",
    "1279": "ਹਸਪਤਾਲ ਪ੍ਰਤੀਨਿਧੀ ਦਾ ਨਾਮ",
    "1280": "ਹਸਪਤਾਲ ਪ੍ਰਤੀਨਿਧੀ ਦਾ ਅਹੁਦਾ",
    "1281": "ਮੈਂ, {name}, ਅਹੁਦਾ {designation}, ਉੱਪਰ ਦੱਸੇ ਗਏ ਹਰੇਕ ਆਧਾਰ ਕਾਰਡ/ਵੋਟਰ ਆਈਡੀ ਅਤੇ ਆਮਦਨ ਸਬੂਤ (ਸਥਾਨਕ ਭਾਸ਼ਾਵਾਂ ਵਾਲੇ ਸਮੇਤ) ਨੂੰ ਦੇਖ ਲਿਆ ਹੈ ਅਤੇ ਇਹ ਵੀ ਯਕੀਨੀ ਬਣਾਉਂਦਾ/ਬਣਾਉਂਦੀ ਹਾਂ ਕਿ ਵੇਰਵੇ ਬਿਨੈ-ਪੱਤਰ ਵਿੱਚ ਦਿੱਤੇ ਵੇਰਵਿਆਂ ਨਾਲ ਮੇਲ ਖਾਂਦੇ ਹਨ।",
    "1285": "ਉੱਚ ਸਿੱਖਿਆ ਯੋਗਤਾ",
    "1286": "ਮਾਂ ਦੀ ਪਛਾਣ ਪੱਤਰ ਦੀ ਕਿਸਮ",
    "1287": "ਪਿਤਾ ਦੀ ਪਛਾਣ ਪੱਤਰ ਦੀ ਕਿਸਮ",
    "1288": "ਸਰਪ੍ਰਸਤ ਦੀ ਪਛਾਣ ਪੱਤਰ ਦੀ ਕਿਸਮ",
    "1289": "ਮਾਂ ਦਾ ਆਧਾਰ ਕਾਰਡ ਨੰਬਰ",
    "1290": "ਮਾਂ ਦਾ ਵੋਟਰ ਕਾਰਡ ਨੰਬਰ",
    "1291": "ਪਿਤਾ ਦਾ ਆਧਾਰ ਕਾਰਡ ਨੰਬਰ",
    "1292": "ਪਿਤਾ ਦਾ ਵੋਟਰ ਕਾਰਡ ਨੰਬਰ",
    "1293": "ਸਰਪ੍ਰਸਤ ਦਾ ਆਧਾਰ ਕਾਰਡ ਨੰਬਰ",
    "1294": "ਸਰਪ੍ਰਸਤ ਦਾ ਵੋਟਰ ਕਾਰਡ ਨੰਬਰ",
    "1295": "ਸਰਪ੍ਰਸਤ ਦਾ ਸੰਬੰਧ",
    "1296": "ਜਮਾਂਦਰੂ ਦਿਲ ਦੇ ਨੁਕਸ ਦਾ ਮਾਮਲਾ - ਟਿੱਪਣੀ - ਕਿਰਪਾ ਕਰਕੇ ਦੱਸੋ",
    "1297": "ਈਕੋ ਰਿਪੋਰਟ ਦਸਤਾਵੇਜ਼",
    "1298": "ਅਨੁਮਾਨ ਪੱਤਰ ਦਸਤਾਵੇਜ਼",
    "1299": "ਆਮਦਨ ਪ੍ਰਮਾਣ ਦਸਤਾਵੇਜ਼",
    "1300": "ਪਰਿਵਾਰਿਕ ਫ਼ੋਟੋ",
    "1301": "ਸਰਪ੍ਰਸਤ ਦੇ ਆਧਾਰ ਅਤੇ ਵੋਟਰ ਆਈਡੀ ਦੀ ਤਸਦੀਕ",
  },

  Kannada: {
    "1128": "ಸಮ್ಮತಿ ಭಾಷೆ",
    "1132": "ಸಮ್ಮತಿ ಸಹಿ ಮಾಡಿದ ವಿಭಾಗ",
    "1131": "ಕ್ರಮದ ಪ್ರಕಾರ",
    "1133": "ಯಾವುದಕ್ಕಾಗಿ ಸಮ್ಮತಿ ಸಹಿ ಮಾಡಲಾಗಿದೆ",
    "1134": "ಸಮ್ಮತಿ ಸಹಿ ಮಾಡಿದವರು",
    "1135": "ಸಮ್ಮತಿ ಲಗತ್ತು",
    "1136": "ಹಿಂಪಡೆಯುವ ಕಾರಣ",
    "1137": "ದಿನಾಂಕ",
    "1138": "ಹಿಂಪಡೆಯುವಿಕೆ ಜಾರಿಗೆ ಬರುವ ದಿನಾಂಕ",
    "1282": "ಯಾವುದಕ್ಕಾಗಿ ಸಮ್ಮತಿ ಸಹಿ ಮಾಡಲಾಗಿಲ್ಲ",
    "1283": "ಪಾಲಕರ ಹೆಸರು",
    "1284": "ಪಾಲಕರ ಸಂಬಂಧ",
    "1139": "ಸಮ್ಮತಿ ಅಂತಿಮ ಸ್ಥಿತಿ",
    "1140": "ಪ್ರಕರಣ ಸ್ವೀಕೃತ ದಿನಾಂಕ",
    "1141": "ಪ್ರಕರಣದ ಮೂಲ",
    "1142": "ಬೇರೆ ಆದರೆ ದಯವಿಟ್ಟು ನಿರ್ದಿಷ್ಟಪಡಿಸಿ",
    "1143": "GF ಬೆಂಬಲಿತ ತಪಾಸಣಾ ಶಿಬಿರ",
    "1144": "ತಪಾಸಣಾ ಶಿಬಿರ ಆಸ್ಪತ್ರೆ ಸ್ಥಳ",
    "1145": "ಔಟ್ ರೀಚ್ OPD ಸ್ಥಳ",
    "1146": "ಉಲ್ಲೇಖಿಸಲಾದ ಆಸ್ಪತ್ರೆ ಹೆಸರು",
    "1147": "ಉಲ್ಲೇಖಿಸಲಾದ ಆಸ್ಪತ್ರೆ ಸ್ಥಳ",
    "1148": "ಫಲಾನುಭವಿಯ ಪೂರ್ಣ ಹೆಸರು",
    "1149": "ಅಪರನಾಮ / ಅಡ್ಡಹೆಸರು",
    "1150": "ವಯಸ್ಸಿನ ಮೌಲ್ಯ",
    "1151": "ವಯಸ್ಸಿನ ಘಟಕ (ದಿನಗಳು/ತಿಂಗಳುಗಳು/ವರ್ಷಗಳಲ್ಲಿ)",
    "1152": "ವಯಸ್ಸಿನ ವರ್ಗ",
    "1153": "ಲಿಂಗ",
    "1154": "ಧರ್ಮ",
    "1155": "ದೇಹದ ತೂಕ (ಕಿ.ಗ್ರಾಂ.)",
    "1156": "ಶಿಕ್ಷಣ ಸ್ಥಿತಿ",
    "1157": "ಶಾಲೆ/ಕಾಲೇಜಿನ ಹೆಸರು",
    "1158": "ಫಲಾನುಭವಿ ಗುರುತಿನ ಪುರಾವೆ",
    "1159": "ಆಧಾರ್ ಕಾರ್ಡ್ ಸಂಖ್ಯೆ",
    "1160": "ಆಸ್ಪತ್ರೆಯಿಂದ ಆಧಾರ್ ಕಾರ್ಡ್ ಪರಿಶೀಲಿಸಲಾಗಿದೆಯೇ?",
    "1161": "GF ಜೊತೆ ಜನ್ಮ ಪ್ರಮಾಣಪತ್ರ ಹಂಚಿಕೊಳ್ಳಲಾಗಿದೆ",
    "1162": "ಪರಿಶೀಲನಾ ನಮೂನೆಯನ್ನು ಆಸ್ಪತ್ರೆಯು ಭರ್ತಿ ಮಾಡಿ ಸಹಿ ಮಾಡಿದೆ",
    "1163": "ಪೋಷಕರ ಸ್ಥಿತಿ",
    "1164": "ಮಗು ಯಾರೊಂದಿಗೆ ವಾಸಿಸುತ್ತಿದೆ",
    "1165": "ತಾಯಿಯ ಹೆಸರು",
    "1166": "ತಾಯಿಯ ವಯಸ್ಸು",
    "1167": "ತಾಯಿಯ ವೃತ್ತಿ",
    "1168": "ತಾಯಿಯ ಮಾಸಿಕ ಆದಾಯ",
    "1169": "ತಂದೆಯ ಹೆಸರು",
    "1170": "ತಂದೆಯ ವಯಸ್ಸು",
    "1171": "ತಂದೆಯ ವೃತ್ತಿ",
    "1172": "ತಂದೆಯ ಮಾಸಿಕ ಆದಾಯ",
    "1173": "ಪಾಲಕರ ಹೆಸರು",
    "1174": "ಪಾಲಕರ ವಯಸ್ಸು",
    "1175": "ಪಾಲಕರ ವೃತ್ತಿ",
    "1176": "ಪಾಲಕರ ಮಾಸಿಕ ಆದಾಯ",
    "1177": "ಒಟ್ಟು ಕುಟುಂಬ ಆದಾಯ",
    "1178": "ವಿಳಾಸದ ಮೂಲ",
    "1179": "ಪೂರ್ಣ ವಿಳಾಸ",
    "1180": "ಪ್ರಾಥಮಿಕ ಸಂಪರ್ಕ ವ್ಯಕ್ತಿ",
    "1181": "ಪ್ರಾಥಮಿಕ ಸಂಪರ್ಕ ಸಂಖ್ಯೆ",
    "1182": "ಪರ್ಯಾಯ ಸಂಪರ್ಕ ಸಂಖ್ಯೆ",
    "1183": "ಫಲಾನುಭವಿಯ ಒಡಹುಟ್ಟಿದವರ ಸಂಖ್ಯೆ",
    "1184": "ಫಲಾನುಭವಿಯ ಖಾಯಂ ವಿಳಾಸ",
    "1185": "ರಾಜ್ಯ",
    "1186": "ಪೋಷಕರ/ಸಂರಕ್ಷಕರ ಪ್ರದೇಶ",
    "1206": "ಜಿಲ್ಲೆ",
    "1207": "ಇದು ಆಕಾಂಕ್ಷಿ ಜಿಲ್ಲೆಯೇ?",
    "1208": "ಗ್ರಾಮ/ಪ್ರದೇಶದ ಹೆಸರು",
    "1209": "ಭೌಗೋಳಿಕ ವರ್ಗೀಕರಣ",
    "1210": "ಬುಡಕಟ್ಟು ಪ್ರದೇಶ",
    "1211": "ಇದು ಜನ್ಮಜಾತ ಹೃದಯ ದೋಷ ಪ್ರಕರಣವೇ?",
    "1212": "ಶಸ್ತ್ರಚಿಕಿತ್ಸೆಗೆ ಮುಂಚಿನ ಲಕ್ಷಣಗಳು",
    "1213": "ಪ್ರಕರಣ ಪ್ರಕಾರ",
    "1229": "ರೋಗ ನಿರ್ಣಯ",
    "1230": "ಶಿಫಾರಸು ಮಾಡಿದ ಚಿಕಿತ್ಸೆ",
    "1231": "ಶಸ್ತ್ರಚಿಕಿತ್ಸೆಯ ಪ್ರಕಾರ",
    "1232": "ಇದು VSD ಸಾಧನ ಮುಚ್ಚುವಿಕೆಯೇ (Device Closure)?",
    "1233": "ಇದು ಸಿಂಗಲ್ ವೆಂಟ್ರಿಕಲ್ ಫಿಸಿಯಾಲಜಿಯೇ?",
    "1234": "ಇದು ಹೈಪೋಪ್ಲಾಸ್ಟಿಕ್ ಹಾರ್ಟ್ ಪ್ರಕರಣವೇ?",
    "1235": "ಡೌನ್ ಸಿಂಡ್ರೋಮ್ ಅಥವಾ ಇತರ ಪ್ರಮುಖ ಆನುವಂಶಿಕ ಸ್ಥಿತಿಯೊಂದಿಗೆ CHD ಪ್ರಕರಣವೇ?",
    "1236": "ಹೃದಯ ಕಸಿ ಅಗತ್ಯವಿದೆಯೇ?",
    "1237": "ಇದು ಪುನರಾವರ್ತಿತ ಶಸ್ತ್ರಚಿಕಿತ್ಸೆಯೇ (Re-do Surgery)?",
    "1238": "ಇದು ವಾಲ್ವ್ ದುರಸ್ತಿ/ಬದಲಾವಣೆಯೇ?",
    "1239": "ಈ ಮಗುವಿಗೆ ಈ ಹಿಂದೆ GF ನಿಂದ ಬೆಂಬಲ ನೀಡಲಾಗಿದೆಯೇ?",
    "1240": "ಫಲಾನುಭವಿಯ ಸಂಕ್ಷಿಪ್ತ ವೈದ್ಯಕೀಯ ವಿವರಗಳು",
    "1241": "ಶಸ್ತ್ರಚಿಕಿತ್ಸೆಯ ಅಂದಾಜು ವೆಚ್ಚ",
    "1242": "ಕುಟುಂಬದ ಅಂದಾಜು ಕೊಡುಗೆ",
    "1243": "ಆಸ್ಪತ್ರೆಯಿಂದ ಅಂದಾಜು ರಿಯಾಯಿತಿ",
    "1244": "ಕುಟುಂಬದ ಕೊಡುಗೆಯ ಮೂಲ",
    "1245": "ಆಸ್ಪತ್ರೆ ಚಾರಿಟಿ ಸೆಲ್‌ನ ಅಂದಾಜು ಕೊಡುಗೆ",
    "1246": "ಇತರ ಕೊಡುಗೆ ಮೊತ್ತ",
    "1247": "ಆಸ್ಪತ್ರೆ ಚಾರಿಟಿ ಸೆಲ್ - ಟಿಪ್ಪಣಿ",
    "1248": "ಇತರ ಕೊಡುಗೆ - ಟಿಪ್ಪಣಿ",
    "1249": "ಇತರ ಕೊಡುಗೆ - ಫೈಲ್‌ಗಳು",
    "1250": "GF ನ ಗರಿಷ್ಠ ಕೊಡುಗೆ",
    "1251": "ಆಸ್ಪತ್ರೆ ಹೆಸರು",
    "1252": "ಚಿಕಿತ್ಸೆ ನೀಡುತ್ತಿರುವ ವೈದ್ಯ",
    "1253": "ನನಗೆ ಸಮ್ಮತಿ ಫಾರ್ಮ್, ಅರ್ಜಿ ಫಾರ್ಮ್ ಮತ್ತು ಘೋಷಣಾ ಫಾರ್ಮ್‌ನ ಪ್ರತಿಯನ್ನು ನೀಡಲಾಗಿದೆ",
    "1254": "ಮೇಲೆ ನೀಡಿದ ಮಾಹಿತಿ ನಿಜ ಮತ್ತು ಸಂಪೂರ್ಣ",
    "1255": "ಮೇಲೆ ವಿವರಿಸಿದ ನನ್ನ ಮಗುವಿನ (ಫಲಾನುಭವಿ) ಚಿಕಿತ್ಸೆಯ ವೆಚ್ಚವನ್ನು ಭರಿಸಲು ನನ್ನಿಂದ ಸಾಧ್ಯವಿಲ್ಲ",
    "1263": "ಮಗುವಿನ ಚಿಕಿತ್ಸೆಗೆ ಆರ್ಥಿಕ ಮತ್ತು ಇತರ ನೆರವನ್ನು ಉಚಿತ ಮತ್ತು ಪರೋಪಕಾರಿ ಮನೋಭಾವದಿಂದ ನೀಡಲಾಗುತ್ತಿದೆ ಎಂದು ನಾನು ಒಪ್ಪಿಕೊಳ್ಳುತ್ತೇನೆ. ಜೆನೆಸಿಸ್ ಫೌಂಡೇಶನ್, ಅದರ ಟ್ರಸ್ಟಿಗಳು, ಅಧಿಕಾರಿಗಳು, ನೌಕರರು ಮತ್ತು ಸ್ವಯಂಸೇವಕರು ನನ್ನ ಮಗುವಿನ ಚಿಕಿತ್ಸೆಗೆ ಸಂಬಂಧಿಸಿದ ಯಾವುದೇ ಹೊಣೆಗಾರಿಕೆಯನ್ನು ಹೊಂದಿರುವುದಿಲ್ಲ ಎಂದು ನಾನು ದೃಢೀಕರಿಸುತ್ತೇನೆ.",
    "1257": "ಪೋಷಕರು/ಪಾಲಕರು ಮೇಲಿನ ಎಲ್ಲಾ ಘೋಷಣೆಗಳಿಗೆ ಒಪ್ಪಿಗೆ ನೀಡುತ್ತಾರೆಯೇ?",
    "1258": "ಅರ್ಜಿ ನಮೂನೆ ಭರ್ತಿ ಮಾಡಿದವರು",
    "1259": "ಹುದ್ದೆ",
    "1260": "ಜನ್ಮ ಪ್ರಮಾಣಪತ್ರ ದಾಖಲೆ",
    "1261": "ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ ಮೊದಲು ಫಲಾನುಭವಿ ಫೋಟೋ",
    "1264": "ಮಾನ್ಯ ಜನ್ಮ ಪ್ರಮಾಣಪತ್ರ ಸಲ್ಲಿಸಲಾಗಿದೆ ಎಂದು ನಾನು ದೃಢಪಡಿಸುತ್ತೇನೆ. ಆದ್ದರಿಂದ ಫಲಾನುಭವಿಯ ಪರಿಶೀಲನೆ ವಿವರಗಳ ಅಗತ್ಯವಿಲ್ಲ ಮತ್ತು ಪರಿಶೀಲನೆ ವಿಭಾಗವನ್ನು ಬಿಟ್ಟುಬಿಡಬಹುದು.",
    "1265": "ಫಲಾನುಭವಿಯ ಹೆಸರು",
    "1266": "ಫಲಾನುಭವಿಯ ಲಿಂಗ",
    "1267": "ಫಲಾನುಭವಿಯ ಗುರುತಿನ ಪುರಾವೆ ಪರಿಶೀಲನೆ",
    "1269": "ಫಲಾನುಭವಿಯ ತಾಯಿಯ ಹೆಸರು",
    "1270": "ತಾಯಿಯ ಆಧಾರ್ ಮತ್ತು ಮತದಾರ ಐಡಿ ಪರಿಶೀಲನೆ",
    "1271": "ತಾಯಿಯ ಮತದಾರ ಗುರುತಿನ ಚೀಟಿ ಪರಿಶೀಲನೆ",
    "1272": "ಫಲಾನುಭವಿಯ ತಂದೆಯ ಹೆಸರು",
    "1273": "ತಂದೆಯ ಆಧಾರ್ ಮತ್ತು ಮತದಾರ ಐಡಿ ಪರಿಶೀಲನೆ",
    "1274": "ತಂದೆಯ ಮತದಾರ ಗುರುತಿನ ಚೀಟಿ ಪರಿಶೀಲನೆ",
    "1275": "ಆದಾಯ ಗಳಿಸುವ ಕುಟುಂಬ ಸದಸ್ಯರ ಹೆಸರು",
    "1276": "ಮಾಸಿಕ ಆದಾಯ",
    "1277": "ವಾರ್ಷಿಕ ಆದಾಯ",
    "1278": "ಸಲ್ಲಿಸಿದ ಆದಾಯ ಪುರಾವೆಯ ಭಾಷೆ",
    "1279": "ಆಸ್ಪತ್ರೆ ಪ್ರತಿನಿಧಿಯ ಹೆಸರು",
    "1280": "ಆಸ್ಪತ್ರೆ ಪ್ರತಿನಿಧಿಯ ಹುದ್ದೆ",
    "1281": "ನಾನು, {name}, ಹುದ್ದೆ {designation}, ಮೇಲೆ ತಿಳಿಸಲಾದ ಪ್ರತಿ ಆಧಾರ್ ಕಾರ್ಡ್/ಮతದಾರರ ಗುರುತಿನ ಚೀಟಿ ಮತ್ತು ಆದಾಯ ಪುರಾವೆಯನ್ನು (ಸ್ಥಳীয় ಭಾಷೆಗಳಲ್ಲಿ ಇರುವುದೂ ಸೇರಿ) ನೋಡಿದ್ದೇನೆ ಮತ್ತು ವಿವರಗಳು ಅರ್ಜಿ ನಮೂನೆಯಲ್ಲಿರುವ ವಿವರಗಳಿಗೆ ಹೊಂದಾಣಿಕೆಯಾಗುತ್ತಿವೆ ಎಂದು ಖಚಿತಪಡಿಸುತ್ತೇನೆ।",
    "1285": "ಉನ್ನತ ಶಿಕ್ಷಣ ಅರ್ಹತೆ",
    "1286": "ತಾಯಿಯ ಗುರುತಿನ ಪ್ರಮಾಣ ಪ್ರಕಾರ",
    "1287": "ತಂದೆಯ ಗುರುತಿನ ಪ್ರಮಾಣ ಪ್ರಕಾರ",
    "1288": "ಪಾಲಕರ ಗುರುತಿನ ಪ್ರಮಾಣ ಪ್ರಕಾರ",
    "1289": "ತಾಯಿಯ ಆಧಾರ್ ಕಾರ್ಡ್ ಸಂಖ್ಯೆ",
    "1290": "ತಾಯಿಯ ಮತದಾರ ಕಾರ್ಡ್ ಸಂಖ್ಯೆ",
    "1291": "ತಂದೆಯ ಆಧಾರ್ ಕಾರ್ಡ್ ಸಂಖ್ಯೆ",
    "1292": "ತಂದೆಯ ಮತದಾರ ಕಾರ್ಡ್ ಸಂಖ್ಯೆ",
    "1293": "ಪಾಲಕರ ಆಧಾರ್ ಕಾರ್ಡ್ ಸಂಖ್ಯೆ",
    "1294": "ಪಾಲಕರ ಮತದಾರ ಕಾರ್ಡ್ ಸಂಖ್ಯೆ",
    "1295": "ಪಾಲಕರ ಸಂಬಂಧ",
    "1296": "ಜನ್ಮಜಾತ ಹೃದಯ ದೋಷ ಪ್ರಕರಣ - ಟಿಪ್ಪಣಿ - ದಯವಿಟ್ಟು ನಿರ್ದಿಷ್ಟಪಡಿಸಿ",
    "1297": "ಇಕೋ ರಿಪೋರ್ಟ್ ದಾಖಲೆ",
    "1298": "ಅಂದಾಜು ಪತ್ರ ದಾಖಲೆ",
    "1299": "ಆದಾಯ ಪ್ರಮಾಣ ದಾಖಲೆ",
    "1300": "ಕುಟುಂಬ ಫೋಟೋ",
    "1301": "ಪಾಲಕರ ಆಧಾರ್ ಮತ್ತು ಮತದಾರ ಐಡಿ ಪರಿಶೀಲನೆ",
  },

  Malayalam: {
    "1128": "സമ്മത ഭാഷ",
    "1132": "സമ്മത ഒപ്പിട്ട വിഭാഗം",
    "1131": "നടപടി തരം",
    "1133": "സമ്മതം ഒപ്പിട്ടത് എന്തിനായി",
    "1134": "സമ്മതം ഒപ്പിട്ടത് ആരാണ്",
    "1135": "സമ്മതപത്രം അറ്റാച്ച്മെന്റ്",
    "1136": "റദ്ദാക്കാനുള്ള കാരണം",
    "1137": "തീയതി",
    "1138": "റദ്ദാക്കൽ പ്രാബല്യത്തിൽ വരുന്ന തീയതി",
    "1282": "സമ്മതം ഒപ്പിടാത്ത കാര്യങ്ങൾ",
    "1283": "രക്ഷകർത്താവിന്റെ പേര്",
    "1284": "രക്ഷകർത്താവിന്റെ ബന്ധം",
    "1139": "സമ്മതത്തിന്റെ അന്തിമ നില",
    "1140": "കേസ് ലഭിച്ച തീയതി",
    "1141": "കേസിന്റെ ഉറവിടം",
    "1142": "മറ്റൊന്നാണെങ്കിൽ, ദയവായി വ്യക്തമാക്കുക",
    "1143": "GF സഹായിച്ച സ്ക്രീനിങ് ക്യാമ്പ്",
    "1144": "സ്ക്രീനിങ് ക്യാമ്പ് ആശുപത്രി സ്ഥലം",
    "1145": "ഔട്ട്‌ റീച്ച് OPD സ്ഥലം",
    "1146": "റഫർ ചെയ്ത ആശുപത്രിയുടെ പേര്",
    "1147": "റഫർ ചെയ്ത ആശുപത്രിയുടെ സ്ഥലം",
    "1148": "ഗുണഭോക്താവിന്റെ പൂർണ്ണ നാമം",
    "1149": "അപരനാമം / മറ്റ് പേര്",
    "1150": "പ്രായ മൂല്യം",
    "1151": "പ്രായത്തിന്റെ യൂണിറ്റ് (ദിവസങ്ങൾ/മാസങ്ങൾ/വർഷങ്ങളിൽ)",
    "1152": "പ്രായ വർഗ്ഗം",
    "1153": "ലിംഗം",
    "1154": "മതം",
    "1155": "ശരീര ഭാരം (കിലോഗ്രാം)",
    "1156": "വിദ്യാഭ്യാസ നില",
    "1157": "സ്കൂൾ/കോളേജിന്റെ പേര്",
    "1158": "ഗുണഭോക്താവിന്റെ ഐഡി തെളിവ്",
    "1159": "ആധാർ കാർഡ് നമ്പർ",
    "1160": "ആശുപത്രി ആധാർ കാർഡ് പരിശോധിച്ചോ?",
    "1161": "ജനന സർട്ടിഫിക്കറ്റ് GF-ൽ പങ്കിട്ടു",
    "1162": "സ്ഥിരീകരണ ഫോം ആശുപത്രി പൂരിപ്പിച്ച് ഒപ്പിട്ടത്",
    "1163": "മാതാപിതാക്കളുടെ അവസ്ഥ",
    "1164": "കുട്ടി ആരുടെ കൂടെയാണ് താമസിക്കുന്നത്",
    "1165": "അമ്മയുടെ പേര്",
    "1166": "അമ്മയുടെ പ്രായം",
    "1167": "അമ്മയുടെ തൊഴിൽ",
    "1168": "അമ്മയുടെ പ്രതിമാസ വരുമാനം",
    "1169": "അച്ഛന്റെ പേര്",
    "1170": "അച്ഛന്റെ പ്രായം",
    "1171": "അച്ഛന്റെ തൊഴിൽ",
    "1172": "അച്ഛന്റെ പ്രതിമാസ വരുമാനം",
    "1173": "രക്ഷകർത്താവിന്റെ പേര്",
    "1174": "രക്ഷകർത്താവിന്റെ പ്രായം",
    "1175": "രക്ഷകർത്താവിന്റെ തൊഴിൽ",
    "1176": "രക്ഷകർത്താവിന്റെ പ്രതിമാസ വരുമാനം",
    "1177": "കുടുംബത്തിന്റെ മൊത്തം വരുമാനം",
    "1178": "മേൽവിലാസ ഉറവിടം",
    "1179": "പൂർണ്ണ മേൽവിലാസം",
    "1180": "പ്രാഥമിക ബന്ധപ്പെടേണ്ട വ്യക്തി",
    "1181": "പ്രാഥമിക ബന്ധപ്പെടേണ്ട നമ്പർ",
    "1182": "ബദൽ ബന്ധപ്പെടേണ്ട നമ്പർ",
    "1183": "ഗുണഭോക്താവിന്റെ സഹോദരങ്ങളുടെ എണ്ണം",
    "1184": "ഗുണഭോക്താവിന്റെ സ്ഥിര മേൽവിലാസം",
    "1185": "സംസ്ഥാനം",
    "1186": "രക്ഷകർത്താക്കളുടെ/കാര്യദർശിയുടെ മേഖല",
    "1206": "ജില്ല",
    "1207": "ഇത് ആഗ്രഹജില്ലയോ?",
    "1208": "ഗ്രാമം/പ്രദേശത്തിന്റെ പേര്",
    "1209": "ഭൂമിശാസ്ത്രപരമായ വർഗ്ഗീകരണം",
    "1210": "ആദിവാസി പ്രദേശം",
    "1211": "ജന്മനായുള്ള ഹൃദ്രോഗ കേസാണോ?",
    "1212": "ശസ്ത്രക്രിയയ്ക്ക് മുമ്പുള്ള ലക്ഷണങ്ങൾ",
    "1213": "കേസ് തരം",
    "1229": "രോഗനിർണ്ണയം",
    "1230": "നിർദ്ദേശിച്ച ചികിത്സ",
    "1231": "ശസ്ത്രക്രിയയുടെ തരം",
    "1232": "വിഎസ്ഡി ഡിവൈസ് ക്ലോഷർ ആണോ?",
    "1233": "സിംഗിൾ വെൻട്രിക്കിൾ ഫിസിയോളജി ആണോ?",
    "1234": "ഹൈപ്പോപ്ലാസ്റ്റിക് ഹാർട്ട് ആണോ?",
    "1235": "ഡൗൺ സിൻഡ്രോമോ മറ്റ് പ്രധാന ജനിതക അവസ്ഥയോ ഉള്ള CHD കേസാണോ?",
    "1236": "ഹൃദയം മാറ്റിവയ്ക്കൽ ആവശ്യമുണ്ടോ?",
    "1237": "വീണ്ടും ശസ്ത്രക്രിയ (Re-do Surgery) ആവശ്യമാണോ?",
    "1238": "വാൽവ് നന്നാക്കൽ/മാറ്റിസ്ഥാപിക്കൽ ആണോ?",
    "1239": "ഈ കുട്ടിക്ക് മുമ്പ് GF വഴി സഹായം ലഭിച്ചിട്ടുണ്ടോ?",
    "1240": "ഗുണഭോക്താവിന്റെ സംക്ഷിപ്ത മെഡിക്കൽ വിവരങ്ങൾ",
    "1241": "ശസ്ത്രക്രിയയുടെ ഏകദേശ ചെലവ്",
    "1242": "കുടുംബത്തിന്റെ കണക്കാക്കിയ സംഭാവന",
    "1243": "ആശുപത്രി നൽകുന്ന കണക്കാക്കിയ കിഴിവ്",
    "1244": "കുടുംബ സംഭാവനയുടെ ഉറവിടം",
    "1245": "ആശുപത്രി ചാരിറ്റി സെല്ലിന്റെ കണക്കാക്കിയ സംഭാവന",
    "1246": "മറ്റ് സംഭാവന തുക",
    "1247": "ആശുപത്രി ചാരിറ്റി സെൽ - അഭിപ്രായം",
    "1248": "മറ്റ് സംഭാവന - അഭിപ്രായം",
    "1249": "മറ്റ് സംഭാവന - ഫയലുകൾ",
    "1250": "GF-ൽ നിന്നുള്ള പരമാവധി സംഭാവന",
    "1251": "ആശുപത്രിയുടെ പേര്",
    "1252": "ചികിത്സിക്കുന്ന ഡോക്ടർ",
    "1253": "എനിക്ക് സമ്മത ഫോം, അപേക്ഷ ഫോം, പ്രഖ്യാപന ഫോം എന്നിവയുടെ പകർപ്പ് ലഭിച്ചു",
    "1254": "മേലേ നൽകിയ വിവരങ്ങൾ സത്യവും പൂർണ്ണവും ആണ്",
    "1255": "മുകളിൽ വിവരിച്ച എന്റെ കുട്ടിയുടെ (ഗുണഭോക്താവ്) ചികിത്സാ ചെലവ് വഹിക്കാൻ എനിക്ക് സാധ്യമല്ല",
    "1263": "കുട്ടിയുടെ ചികിത്സയ്ക്കുള്ള സാമ്പത്തിക ഉൾപ്പെടെ മറ്റ് സഹായം ഒരു സൗജന്യ പരോപകാര മനോഭാവത്തോടെ നൽകുന്നു എന്ന് ഞാൻ അംഗീകരിക്കുന്നു. ജെനസിസ് ഫൗണ്ടേഷനും അതിന്റെ ട്രസ്റ്റികൾ, ഉദ്യോഗസ്ഥർ, ജീവനക്കാർ, സന്നദ്ധപ്രവർത്തകർ എന്നിവർക്കും എന്റെ കുട്ടിയുടെ ചികിത്സയുമായി ബന്ധപ്പെട്ട് ഒരു ബാധ്യതയും ഉണ്ടായിരിക്കില്ല എന്ന് ഞാൻ ഉറപ്പ് നൽകുന്നു.",
    "1257": "മാതാപിതാക്കൾ/രക്ഷകർത്താവ് മുകളിലെ എല്ലാ പ്രഖ്യാപനങ്ങളോടും യോജിക്കുന്നുണ്ടോ?",
    "1258": "അപേക്ഷാ ഫോം പൂരിപ്പിച്ചത്",
    "1259": "പദവി",
    "1260": "ജനന സർട്ടിഫിക്കറ്റ് രേഖ",
    "1261": "ശസ്ത്രക്രിയയ്ക്ക് മുമ്പ് ഗുണഭോക്താവിന്റെ ഫോട്ടോ",
    "1264": "ഒരു സാധുവായ ജനന സർട്ടിഫിക്കറ്റ് സമർപ്പിച്ചിട്ടുണ്ടെന്ന് ഞാൻ സ്ഥിരീകരിക്കുന്നു. അതിനാൽ ഗുണഭോക്താവിന്റെ സ്ഥിരീകരണ വിവരങ്ങൾ ആവശ്യമില്ല, സ്ഥിരീകരണ വിഭാഗം ഒഴിവാക്കാം.",
    "1265": "ഗുണഭോക്താവിന്റെ പേര്",
    "1266": "ഗുണഭോക്താവിന്റെ ലിംഗം",
    "1267": "ഗുണഭോക്താവിന്റെ തിരിച്ചറിയൽ രേഖ പരിശോധന",
    "1269": "ഗുണഭോക്താവിന്റെ അമ്മയുടെ പേര്",
    "1270": "അമ്മയുടെ ആധാർ & വോട്ടർ ഐഡി സ്ഥിരീകരണം",
    "1271": "അമ്മയുടെ വോട്ടർ ഐഡി സ്ഥിരീകരണം",
    "1272": "ഗുണഭോക്താവിന്റെ അച്ഛന്റെ പേര്",
    "1273": "അച്ഛന്റെ ആധാർ & വോട്ടർ ഐഡി സ്ഥിരീകരണം",
    "1274": "അച്ഛന്റെ വോട്ടർ ഐഡി സ്ഥിരീകരണം",
    "1275": "വരുമാനം ഉള്ള കുടുംബാംഗത്തിന്റെ പേര്",
    "1276": "പ്രതിമാസ വരുമാനം",
    "1277": "വാർഷിക വരുമാനം",
    "1278": "സമർപ്പിച്ച വരുമാന തെളിവിന്റെ ഭാഷ",
    "1279": "ആശുപത്രി പ്രതിനിധിയുടെ പേര്",
    "1280": "ആശുപത്രി പ്രതിനിധിയുടെ തസ്തിക",
    "1281": "ഞാൻ, {name}, തസ്തിക {designation}, മുകളിൽ പറഞ്ഞിരിക്കുന്ന ഓരോ ആധാർ കാർഡും/വോട്ടർ ഐഡിയും വരുമാന തെളിവും (പ്രാദേശിക ഭാഷകളിലുള്ളവ ഉൾപ്പെടെ) പരിശോധിച്ചിട്ടുണ്ടെന്നും വിവരങ്ങൾ അപേക്ഷാ ഫോമിലുള്ളവയുമായി പൊരുത്തപ്പെടുന്നുണ്ടെന്നും ഉറപ്പാക്കുന്നു।",
    "1285": "ഉന്നത വിദ്യാഭ്യാസ യോഗ്യത",
    "1286": "അമ്മയുടെ ഐഡി പ്രൂഫ് തരം",
    "1287": "അച്ഛന്റെ ഐഡി പ്രൂഫ് തരം",
    "1288": "രക്ഷകർത്താവിന്റെ ഐഡി പ്രൂഫ് തരം",
    "1289": "അമ്മയുടെ ആധാർ കാർഡ് നമ്പർ",
    "1290": "അമ്മയുടെ വോട്ടർ കാർഡ് നമ്പർ",
    "1291": "അച്ഛന്റെ ആധാർ കാർഡ് നമ്പർ",
    "1292": "അച്ഛന്റെ വോട്ടർ കാർഡ് നമ്പർ",
    "1293": "രക്ഷകർത്താവിന്റെ ആധാർ കാർഡ് നമ്പർ",
    "1294": "രക്ഷകർത്താവിന്റെ വോട്ടർ കാർഡ് നമ്പർ",
    "1295": "രക്ഷകർത്താവിന്റെ ബന്ധം",
    "1296": "ജന്മനായുള്ള ഹൃദ്രോഗ കേസ് - അഭിപ്രായം - ദയവായി വ്യക്തമാക്കുക",
    "1297": "എക്കോ റിപ്പോർട്ട് രേഖ",
    "1298": "എസ്റ്റിമേറ്റ് ലെറ്റർ രേഖ",
    "1299": "വരുമാന തെളിവ് രേഖ",
    "1300": "കുടുംബ ഫോട്ടോ",
    "1301": "രക്ഷകർത്താവിന്റെ ആധാർ & വോട്ടർ ഐഡി സ്ഥിരീകരണം",
  },

  Tamil: {
    "1128": "ஒப்புதல் மொழி",
    "1132": "ஒப்புதல் கையொப்பமிட்ட பிரிவு",
    "1131": "செயல் வகை",
    "1133": "எதற்காக ஒப்புதல் கையொப்பமிடப்பட்டது",
    "1134": "ஒப்புதல் கையொப்பமிட்டவர்",
    "1135": "ஒப்புதல் இணைப்பு",
    "1136": "ரத்து செய்வதற்கான காரணம்",
    "1137": "தேதி",
    "1138": "ரத்து நடைமுறைக்கு வரும் தேதி",
    "1282": "ஒப்புதல் கையொப்பமிடப்படாதவை",
    "1283": "பாதுகாவலரின் பெயர்",
    "1284": "பாதுகாவலரின் உறவு",
    "1139": "ஒப்புதலின் இறுதி நிலை",
    "1140": "வழக்கு பெறப்பட்ட தேதி",
    "1141": "வழக்கின் மூலம்",
    "1142": "வேறு ஏதேனும் இருந்தால், தயவுசெய்து குறிப்பிடவும்",
    "1143": "GF ஆதரவு தரும் சோதனை முகாம்",
    "1144": "சோதனை முகாம் மருத்துவமனை இடம்",
    "1145": "வெளிப்புற OPD இடம்",
    "1146": "பரிந்துரைக்கப்பட்ட மருத்துவமனை பெயர்",
    "1147": "பரிந்துரைக்கப்பட்ட மருத்துவமனை இடம்",
    "1148": "பயனாளியின் முழுப் பெயர்",
    "1149": "மாற்றுப் பெயர் / புனைப்பெயர்",
    "1150": "வயது மதிப்பு",
    "1151": "வயது அலகு (நாட்கள்/மாதங்கள்/ஆண்டுகளில்)",
    "1152": "வயது வகை",
    "1153": "பாலினம்",
    "1154": "மதம்",
    "1155": "உடல் எடை (கிலோ)",
    "1156": "கல்வி நிலை",
    "1157": "பள்ளி/கல்லூரியின் பெயர்",
    "1158": "பயனாளி அடையாள ஆதாரம்",
    "1159": "ஆதார் அட்டை எண்",
    "1160": "மருத்துவமனையால் ஆதார் அட்டை சரிபார்க்கப்பட்டதா?",
    "1161": "பிறப்பு சான்றிதழ் GF-உடன் பகிரப்பட்டது",
    "1162": "சரிபார்ப்பு படிவம் மருத்துவமனையால் பூர்த்தி செய்யப்பட்டு கையொப்பமிடப்பட்டது",
    "1163": "பெற்றோர் நிலை",
    "1164": "குழந்தை யாருடன் வசிக்கிறது",
    "1165": "தாயின் பெயர்",
    "1166": "தாயின் வயது",
    "1167": "தாயின் தொழில்",
    "1168": "தாயின் மாத வருமானம்",
    "1169": "தந்தையின் பெயர்",
    "1170": "தந்தையின் வயது",
    "1171": "தந்தையின் தொழில்",
    "1172": "தந்தையின் மாத வருமானம்",
    "1173": "பாதுகாவலரின் பெயர்",
    "1174": "பாதுகாவலரின் வயது",
    "1175": "பாதுகாவலரின் தொழில்",
    "1176": "பாதுகாவலரின் மாத வருமானம்",
    "1177": "குடும்பத்தின் மொத்த வருமானம்",
    "1178": "முகவரி மூலம்",
    "1179": "முழு முகவரி",
    "1180": "முதன்மை தொடர்பு நபர்",
    "1181": "முதன்மை தொடர்பு எண்",
    "1182": "மாற்று தொடர்பு எண்",
    "1183": "பயனாளியின் உடன்பிறந்தோரின் எண்ணிக்கை",
    "1184": "பயனாளியின் நிரந்தர முகவரி",
    "1185": "மாநிலம்",
    "1186": "பெற்றோர்/பாதுகாவலர் பகுதி",
    "1206": "மாவட்டம்",
    "1207": "இது ஆசைமாவட்டமா?",
    "1208": "கிராமம்/பகுதியின் பெயர்",
    "1209": "புவியியல் வகைப்பாடு",
    "1210": "பழங்குடியினர் பகுதி",
    "1211": "பிறவி இதய குறைபாடு வழக்கா?",
    "1212": "அறுவை சிகிச்சைக்கு முந்தைய அறிகுறிகள்",
    "1213": "வழக்கு வகை",
    "1229": "நோய் கண்டறிதல்",
    "1230": "பரிந்துரைக்கப்பட்ட சிகிச்சை",
    "1231": "அறுவை சிகிச்சை வகை",
    "1232": "VSD சாதன மூடுதலா?",
    "1233": "சிங்கிள் வென்ட்ரிக்கிள் பிசியாலஜியா?",
    "1234": "ஹைப்போபிளாஸ்டிக் இதயமா?",
    "1235": "டவுன் சிண்ட்ரோம் அல்லது பிற மரபணு குறைபாட்டுடன் கூடிய CHD வழக்கா?",
    "1236": "இதய மாற்று அறுவை சிகிச்சை தேவையா?",
    "1237": "மறு அறுவை சிகிச்சையா (Re-do Surgery)?",
    "1238": "வால்வு பழுது/மாற்று அறுவை சிகிச்சையா?",
    "1239": "இக்குழந்தைக்கு முன்பு GF மூலம் உதவி வழங்கப்பட்டுள்ளதா?",
    "1240": "பயனாளியின் சுருக்கமான மருத்துவ விவரங்கள்",
    "1241": "அறுவை சிகிச்சையின் மதிப்பீட்டு செலவு",
    "1242": "குடும்பத்தின் மதிப்பிடப்பட்ட பங்களிப்பு",
    "1243": "மருத்துவமனையின் மதிப்பிடப்பட்ட தள்ளுபடி",
    "1244": "குடும்ப பங்களிப்பு ஆதாரம்",
    "1245": "மருத்துவமனை அறக்கட்டளை பிரிவின் மதிப்பிடப்பட்ட பங்களிப்பு",
    "1246": "வேறு பங்களிப்பு தொகை",
    "1247": "மருத்துவமனை தர்மசேவை - கருத்து",
    "1248": "வேறு பங்களிப்பு - கருத்து",
    "1249": "வேறு பங்களிப்பு - கோப்புகள்",
    "1250": "GF-ன் அதிகபட்ச பங்களிப்பு",
    "1251": "மருத்துவமனை பெயர்",
    "1252": "சிகிச்சை அளிக்கும் மருத்துவர்",
    "1253": "என்னிடம் ஒப்புதல் படிவம், விண்ணப்பப் படிவம் மற்றும் அறிவிப்பு படிவத்தின் நகல் வழங்கப்பட்டுள்ளது",
    "1254": "மேலே கொடுக்கப்பட்ட தகவல்கள் உண்மையானவை மற்றும் முழுமையானவை",
    "1255": "மேலே விவரிக்கப்பட்ட என் குழந்தையின் (பயனாளி) சிகிச்சைக்கான செலவை என்னால் ஏற்க முடியாது",
    "1263": "குழந்தையின் சிகிச்சைக்கான நிதி மற்றும் பிற உதவிகள் இலவச மற்றும் பரோபகார நோக்கில் வழங்கப்படுகின்றன என்பதை நான் ஒப்புக்கொள்கிறேன். ஜெனீஸிஸ் ஃபவுண்டேஷனும் அதன் அறங்காவலர்கள், அதிகாரிகள், ஊழியர்கள் மற்றும் தன்னார்வலர்களும் என் குழந்தையின் சிகிச்சை தொடர்பான எந்த பொறுப்பையும் ஏற்க மாட்டார்கள் என்று உறுதிபடுத்துகிறேன்.",
    "1257": "பெற்றோர்/பாதுகாவலர் மேலே உள்ள அனைத்து அறிவிப்புகளுக்கும் ஒப்புக்கொள்கிறார்களா?",
    "1258": "விண்ணப்பப் படிவத்தை நிரப்பியவர்",
    "1259": "பதவி",
    "1260": "பிறப்பு சான்றிதழ் ஆவணம்",
    "1261": "அறுவை சிகிச்சைக்கு முன் பயனாளி புகைப்படம்",
    "1264": "செல்லுபடியாகும் பிறப்புச் சான்றிதழ் சமர்ப்பிக்கப்பட்டதை உறுதிப்படுத்துகிறேன். எனவே, பயனாளியின் சரிபார்ப்பு விவரங்கள் தேவையில்லை மற்றும் சரிபார்ப்புப் பகுதியைத் தவிர்க்கலாம்.",
    "1265": "பயனாளியின் பெயர்",
    "1266": "பயனாளியின் பாலினம்",
    "1267": "பயனாளியின் அடையாள சான்று சரிபார்ப்பு",
    "1269": "பயனாளியின் தாயின் பெயர்",
    "1270": "தாயின் ஆதார் & வாக்காளர் அடையாள சரிபார்ப்பு",
    "1271": "தாயின் வாக்காளர் அடையாள சரிபார்ப்பு",
    "1272": "பயனாளியின் தந்தையின் பெயர்",
    "1273": "தந்தையின் ஆதார் & வாக்காளர் அடையாள சரிபார்ப்பு",
    "1274": "தந்தையின் வாக்காளர் அடையாள சரிபார்ப்பு",
    "1275": "வருமானம் ஈட்டும் குடும்ப உறுப்பினரின் பெயர்",
    "1276": "மாதாந்திர வருமானம்",
    "1277": "வருடாந்திர வருமானம்",
    "1278": "சமர்ப்பிக்கப்பட்ட வருமான ஆதாரத்தின் மொழி",
    "1279": "மருத்துவமனை பிரதிநிதியின் பெயர்",
    "1280": "மருத்துவமனை பிரதிநிதியின் பதவி",
    "1281": "நான், {name}, பதவி {designation}, மேலே குறிப்பிட்டுள்ள ஒவ்வொரு ஆதார் அட்டை/வாக்காளர் அடையாள அட்டை மற்றும் வருமானச் சான்றுகளை (வட்டார மொழிகளில் உள்ளவை உட்பட) சரிபார்த்துள்ளேன் மற்றும் விவரங்கள் விண்ணப்பப் படிவத்தில் உள்ளவற்றுடன் பொருந்துவதை உறுதிசெய்கிறேன்.",
    "1285": "உயர் கல்வி தகுதி",
    "1286": "தாயின் அடையாள சான்று வகை",
    "1287": "தந்தையின் அடையாள சான்று வகை",
    "1288": "பாதுகாவலரின் அடையாள சான்று வகை",
    "1289": "தாயின் ஆதார் கார்டு எண்",
    "1290": "தாயின் வாக்காளர் கார்டு எண்",
    "1291": "தந்தையின் ஆதார் கார்டு எண்",
    "1292": "தந்தையின் வாக்காளர் கார்டு எண்",
    "1293": "பாதுகாவலரின் ஆதார் கார்டு எண்",
    "1294": "பாதுகாவலரின் வாக்காளர் கார்டு எண்",
    "1295": "பாதுகாவலரின் உறவு",
    "1296": "பிறவி இதய குறைபாடு வழக்கு - கருத்துரை - தயவுசெய்து குறிப்பிடவும்",
    "1297": "எக்கோ அறிக்கை ஆவணம்",
    "1298": "மதிப்பீட்டு கடித ஆவணம்",
    "1299": "வருமான சான்று ஆவணம்",
    "1300": "குடும்ப புகைப்படம்",
    "1301": "பாதுகாவலரின் ஆதார் & வாக்காளர் அடையாள சரிபார்ப்பு",
  },

  Telugu: {
    "1128": "సమ్మతి భాష",
    "1132": "సమ్మతి సంతకం చేసిన విభాగం",
    "1131": "చర్య రకం",
    "1133": "దేని కొరకు సమ్మతి సంతకం చేయబడింది",
    "1134": "సమ్మతి సంతకం చేసినవారు",
    "1135": "సమ్మతి పత్రం అనుబంధం",
    "1136": "రద్దు కారణం",
    "1137": "తేదీ",
    "1138": "రద్దు అమలు తేదీ",
    "1282": "దేని కొరకు సమ్మతి సంతకం చేయబడలేదు",
    "1283": "సంరక్షకుని పేరు",
    "1284": "సంరక్షకుని సంబంధం",
    "1139": "సమ్మతి తుది స్థితి",
    "1140": "కేసు స్వీకరించిన తేదీ",
    "1141": "కేసు మూలం",
    "1142": "వేరేదైతే, దయచేసి పేర్కొనండి",
    "1143": "GF మద్దతు స్క్రీనింగ్ క్యాంప్",
    "1144": "స్క్రీనింగ్ క్యాంప్ ఆసుపత్రి స్థానం",
    "1145": "అవుట్‌రీచ్ OPD స్థానం",
    "1146": "రెఫర్ చేయబడిన ఆసుపత్రి పేరు",
    "1147": "రెఫర్ చేయబడిన ఆసుపత్రి స్థానం",
    "1148": "లబ్ధిదారుని పూర్తి పేరు",
    "1149": "మారుపేరు",
    "1150": "వయసు విలువ",
    "1151": "వయస్సు ప్రమాణం (రోజులు/నెలలు/సంవత్సరాలలో)",
    "1152": "వయసు వర్గం",
    "1153": "లింగం",
    "1154": "మతం",
    "1155": "శరీర బరువు (కిలోగ్రాములు)",
    "1156": "విద్య స్థితి",
    "1157": "పాఠశాల/కళాశాల పేరు",
    "1158": "లబ్ధిదారు గుర్తింపు నిరూపణ",
    "1159": "ఆధార్ కార్డు నంబర్",
    "1160": "ఆసుపత్రి ద్వారా ఆధార్ కార్డు ధృవీకరించబడిందా?",
    "1161": "జనన ధృవపత్రం GF తో పంచుకోబడింది",
    "1162": "ధృవీకరణ ఫారమ్ ఆసుపత్రి ద్వారా నింపబడి సంతకం చేయబడింది",
    "1163": "తల్లిదండ్రుల స్థితి",
    "1164": "పిల్లవాడు ఎవరితో నివసిస్తున్నాడు",
    "1165": "తల్లి పేరు",
    "1166": "తల్లి వయస్సు",
    "1167": "తల్లి వృత్తి",
    "1168": "తల్లి నెలవారీ ఆదాయం",
    "1169": "తండ్రి పేరు",
    "1170": "తండ్రి వయస్సు",
    "1171": "తండ్రి వృత్తి",
    "1172": "తండ్రి నెలవారీ ఆదాయం",
    "1173": "సంరక్షకుని పేరు",
    "1174": "సంరక్షకుని వయస్సు",
    "1175": "సంరక్షకుని వృత్తి",
    "1176": "సంరక్షకుని నెలవారీ ఆదాయం",
    "1177": "కుటుంబ మొత్తం ఆదాయం",
    "1178": "చిరునామా మూలం",
    "1179": "పూర్తి చిరునామా",
    "1180": "ప్రాథమిక సంప్రదింపు వ్యక్తి",
    "1181": "ప్రాథమిక సంప్రదింపు నంబర్",
    "1182": "ప్రత్యామ్నాయ సంప్రదింపు నంబర్",
    "1183": "లబ్ధిదారు తోబుట్టువుల సంఖ్య",
    "1184": "లబ్ధిదారు శాశ్వత చిరునామా",
    "1185": "రాష్ట్రం",
    "1186": "తల్లిదండ్రులు/సంరక్షకుల ప్రాంతం",
    "1206": "జిల్లా",
    "1207": "ఇది ఆకాంక్షా జిల్లాయా?",
    "1208": "గ్రామం/ప్రాంతం పేరు",
    "1209": "భౌగోళిక వర్గీకరణ",
    "1210": "గిరిజన ప్రాంతం",
    "1211": "ఇది పుట్టుకతో వచ్చిన గుండె లోపం కేసా?",
    "1212": "శస్త్రచికిత్సకు ముందు లక్షణాలు",
    "1213": "కేసు రకం",
    "1229": "రోగ నిర్ధారణ",
    "1230": "సూచించిన చికిత్స",
    "1231": "శస్త్రచికిత్స రకం",
    "1232": "ఇది VSD పరికర మూసివేత (Device Closure) నా?",
    "1233": "ఇది సింగిల్ వెంట్రికిల్ ఫిజియాలజీ నా?",
    "1234": "ఇది హైపోప్లాస్టిక్ హార్ట్ ఆ?",
    "1235": "డౌన్స్ సిండ్రోమ్ లేదా ఇతర జన్యుపరమైన సమస్యతో కూడిన CHD కేసా?",
    "1236": "గుండె మార్పిడి అవసరమా?",
    "1237": "ఇది రీ-డూ శస్త్రచికిత్స (Re-do Surgery) నా?",
    "1238": "ఇది వాల్వ్ మరమ్మతు/మార్పిడి నా?",
    "1239": "ఈ బిడ్డకు గతంలో GF ద్వారా సహాయం అందించబడిందా?",
    "1240": "లబ్ధిదారుని సంక్షిప్త వైద్య వివరాలు",
    "1241": "శస్త్రచికిత్స అంచనా వ్యయం",
    "1242": "కుటుంబం అంచనా వేసిన సహకారం",
    "1243": "ఆసుపత్రి ఇచ్చిన అంచనా తగ్గింపు",
    "1244": "కుటుంబ సహకార మూలం",
    "1245": "ఆసుపత్రి ఛారిటీ సెల్ అంచనా వేసిన సహకారం",
    "1246": "ఇతర సహకార మొత్తం",
    "1247": "ఆసుపత్రి చారిటీ సెల్ - వ్యాఖ్య",
    "1248": "ఇతర సహకారం - వ్యాఖ్య",
    "1249": "ఇతర సహకారం - ఫైళ్లు",
    "1250": "GF నుండి గరిష్ట సహకారం",
    "1251": "ఆసుపత్రి పేరు",
    "1252": "చికిత్స చేసే వైద్యుడు",
    "1253": "నాకు సమ్మతి ఫారమ్, దరఖాస్తు ఫారమ్ మరియు ప్రకటన ఫారమ్ కాపీ ఇవ్వబడింది",
    "1254": "పైన ఇవ్వబడిన సమాచారం నిజమైనది మరియు సంపూర్ణమైనది",
    "1255": "పైన వివరించిన నా బిడ్డ (లబ్ధిదారుడు) చికిత్స ఖర్చులను భరించడానికి నాకు స్తోమత లేదు",
    "1263": "పిల్లవాడి చికిత్సకు ఆర్థిక మరియు ఇతర సహాయం ఉచిత మరియు పరోపకార స్ఫూర్తితో అందించబడుతోందని నేను అంగీకరిస్తున్నాను. జెనెసిస్ ఫౌండేషన్, దాని ట్రస్టీలు, అధికారులు, ఉద్యోగులు మరియు వాలంటీర్లు నా బిడ్డ చికిత్సకు సంబంధించి ఎటువంటి బాధ్యత వహించరని నేను ధృవీకరిస్తున్నాను.",
    "1257": "తల్లిదండ్రులు/సంరక్షకులు పైన పేర్కొన్న అన్ని ప్రకటనలకు అంగీకరిస్తున్నారా?",
    "1258": "దరఖాస్తు ఫారమ్ నింపినవారు",
    "1259": "హోదా",
    "1260": "జనన ధ్రువీకరణ పత్రం",
    "1261": "శస్త్రచికిత్సకు ముందు లబ్ధిదారుని ఫోటో",
    "1264": "చెల్లుబాటు అయ్యే జన్మ ధ్రువీకరణ పత్రం సమర్పించబడిందని నేను నిర్ధారిస్తున్నాను. కావున లబ్ధిదారు యొక్క ధృవీకరణ వివరాలు అవసరం లేదు మరియు ధృవీకరణ విభాగాన్ని వదిలివేయవచ్చు.",
    "1265": "లబ్ధిదారు పేరు",
    "1266": "లబ్ధిదారు లింగం",
    "1267": "లబ్ధిదారుని గుర్తింపు రుజువు ధృవీకరణ",
    "1269": "లబ్ధిదారు తల్లి పేరు",
    "1270": "తల్లి ఆధార్ & ఓటరు గుర్తింపు పత్ర ధృవీకరణ",
    "1271": "తల్లి ఓటర్ ఐడి ధృవీకరణ",
    "1272": "లబ్ధిదారు తండ్రి పేరు",
    "1273": "తండ్రి ఆధార్ & ఓటరు గుర్తింపు పత్ర ధృవీకరణ",
    "1274": "తండ్రి ఓటర్ ఐడి ధృవీకరణ",
    "1275": "సంపాదించే కుటుంబ సభ్యుని పేరు",
    "1276": "నెలవారీ ఆదాయం",
    "1277": "వార్షిక ఆదాయం",
    "1278": "సమర్పించిన ఆదాయ నిరూపణ భాష",
    "1279": "ఆసుపత్రి ప్రతినిధి పేరు",
    "1280": "ఆసుపత్రి ప్రతినిధి హోదా",
    "1281": "నేను, {name}, హోదా {designation}, పైన పేర్కొన్న ప్రతి ఆధార్ కార్డ్/ఓటర్ ఐడి మరియు ఆదాయ ధృవీకరణ పత్రాన్ని (స్థానిక భాషలలో ఉన్నవాటితో సహా) చూశాను మరియు వివరాలు అప్లికేషన్ ఫారమ్‌లోని వివరాలతో సరిపోలుతున్నాయని నిర్ధారిస్తున్నాను.",
    "1285": "ఉన్నత విద్యా అర్హత",
    "1286": "తల్లి గుర్తింపు రుజువు రకం",
    "1287": "తండ్రి గుర్తింపు రుజువు రకం",
    "1288": "సంరక్షకుని గుర్తింపు రుజువు రకం",
    "1289": "తల్లి ఆధార్ కార్డు నంబరు",
    "1290": "తల్లి ఓటరు కార్డు నంబరు",
    "1291": "తండ్రి ఆధార్ కార్డు నంబరు",
    "1292": "తండ్రి ఓటరు కార్డు నంబరు",
    "1293": "సంరక్షకుని ఆధార్ కార్డు నంబరు",
    "1294": "సంరక్షకుని ఓటరు కార్డు నంబరు",
    "1295": "సంరక్షకుని సంబంధం",
    "1296": "జన్మతః హృదయ లోపం కేసు - వ్యాఖ్యలు - దయచేసి పేర్కొనండి",
    "1297": "ఎకో నివేదిక పత్రం",
    "1298": "అంచనా లేఖ పత్రం",
    "1299": "ఆదాయ నిరూపణ పత్రం",
    "1300": "కుటుంబ ఫోటో",
    "1301": "సంరక్షకుని ఆధార్ & ఓటరు గుర్తింపు పత్ర ధృవీకరణ",
  },

  Gujarati: {
    "1128": "સંમતિ ભાષા",
    "1132": "સંમતિ હસ્તાક્ષર વિભાગ",
    "1131": "ક્રિયા પ્રકાર",
    "1133": "જેના માટે સંમતિ સહી કરવામાં આવી",
    "1134": "સંમતિ સહી કરનાર",
    "1135": "સંમતિ જોડાણ",
    "1136": "રદ કરવાનું કારણ",
    "1137": "તારીખ",
    "1138": "રદ કરવાનો અમલી તારીખ",
    "1282": "જેના માટે સંમતિ સહી કરવામાં આવી નથી",
    "1283": "વાલીનું નામ",
    "1284": "વાલીનો સંબંધ",
    "1139": "સંમતિ અંતિમ સ્થિતિ",
    "1140": "કેસ પ્રાપ્ત થવાની તારીખ",
    "1141": "કેસનો સ્ત્રોત",
    "1142": "જો અન્ય, કૃપા કરીને ઉલ્લેખ કરો",
    "1143": "GF સહાયિત સ્ક્રીનિંગ કેમ્પ",
    "1144": "સ્ક્રીનિંગ કેમ્પ હોસ્પિટલ સ્થળ",
    "1145": "આઉટ-રીચ OPD સ્થળ",
    "1146": "સ્થળ-ઉલ્લેખ ઉહ. હોસ્પિટલ નામ",
    "1147": "સ્ળ-ઉલ્લેખ ઉહ. હોસ્પિટલ સ્થળ",
    "1148": "લાભાર્થીનું પૂરું નામ",
    "1149": "ઉપનામ / બીજું નામ",
    "1150": "ઉંમર મૂલ્ય",
    "1151": "ઉંમર એકમ (દિવસો/મહિના/વર્ષોમાં)",
    "1152": "ઉંમર શ્રેણી",
    "1153": "જાતિ",
    "1154": "ધર્મ",
    "1155": "શરીરનું વજન (કિ.ગ્રા.)",
    "1156": "શૈક્ષણિક સ્થિતિ",
    "1157": "શાળા/કોલેજનું નામ",
    "1158": "લાભાર્થી ઓળખ પ્રમાણ",
    "1159": "આધાર કાર્ડ નંબર",
    "1160": "હોસ્પિટલ દ્વારા આધાર કાર્ડ ચકાસણી?",
    "1161": "GF સાથે જન્મ પ્રમાણપત્ર શેર",
    "1162": "ચકાસણી ફોર્મ હોસ્પિટલ દ્વારા ભરેલું અને સહી કરેલું",
    "1163": "માતાપિતાની સ્થિતિ",
    "1164": "બાળક કોની સાથે રહે છે",
    "1165": "માતાનું નામ",
    "1166": "માતાની ઉંમર",
    "1167": "માતાનો વ્યવસાય",
    "1168": "માતાની માસિક આવક",
    "1169": "પિતાનું નામ",
    "1170": "પિતાની ઉંમર",
    "1171": "પિતાનો વ્યવસાય",
    "1172": "પિતાની માસિક આવક",
    "1173": "વાલીનું નામ",
    "1174": "વાલીની ઉંમર",
    "1175": "વાલીનો વ્યવસાય",
    "1176": "વાલીની માસિક આવક",
    "1177": "કુટુંબની કુલ આવક",
    "1178": "સરનામું સ્ત્રોત",
    "1179": "પૂર્ણ સરનામું",
    "1180": "પ્રાથમિક સંપર્ક વ્યક્તિ",
    "1181": "પ્રાથમિક સંપર્ક નંબર",
    "1182": "વૈકલ્પિક સંપર્ક નંબર",
    "1183": "લાભાર્થીના ભાઈ-બહેનોની સંખ્યા",
    "1184": "લાભાર્થીનું કાયમી સરનામું",
    "1185": "રાજ્ય",
    "1186": "માતાપિતા/વાલી ક્ષેત્ર",
    "1206": "જિલ્લો",
    "1207": "શું આ આકાંક્ષી જિલ્લો છે?",
    "1208": "ગામ/વિસ્તારનું નામ",
    "1209": "ભૌગોલિક વર્ગીકરણ",
    "1210": "આદિવાસી વિસ્તાર",
    "1211": "શું જન્મજાત હૃદય ખામીનો કેસ છે?",
    "1212": "શસ્ત્રક્રિયા પહેલાંના લક્ષણો",
    "1213": "કેસ પ્રકાર",
    "1229": "નિદાન",
    "1230": "સૂચવેલ સારવાર",
    "1231": "શસ્ત્રક્રિયાનો પ્રકાર",
    "1232": "શું VSD ડિવાઇસ ક્લોઝર છે?",
    "1233": "શું સિંગલ વેન્ટ્રિકલ ફિઝિયોલોજી છે?",
    "1234": "શું હાયપોપ્લાસ્ટિક હાર્ટ છે?",
    "1235": "ડાઉન સિન્ડ્રોમ કે અન્ય મોટી આનુવંશિક સ્થિતિ સાથે CHD કેસ છે?",
    "1236": "હૃદય પ્રત્યારોપણની જરૂર છે?",
    "1237": "શું ફરીથી શસ્ત્રક્રિયા (રી-ડૂ) છે?",
    "1238": "શું વાલ્વ રિપેર/રિપ્લેસમેન્ટ છે?",
    "1239": "શું આ બાળકને અગાઉ GF દ્વારા સહાય મળી છે?",
    "1240": "લાભાર્થીની સંક્ષિપ્ત તબીબી વિગતો",
    "1241": "ઓપરેશનનો અંદાજિત ખર્ચ",
    "1242": "પરિવારનું અંદાજિત યોગદાન",
    "1243": "હોસ્પિટલ દ્વારા અંદાજિત છૂટ",
    "1244": "કૌટુંબિક યોગદાનનો સ્ત્રોત",
    "1245": "હોસ્પિટલ ચેરિટી સેલનું અંદાજિત યોગદાન",
    "1246": "અન્ય ફાળો રકમ",
    "1247": "હોસ્પિટલ ચેરિટી સેલ - ટિપ્પણી",
    "1248": "અન્ય ફાળો - ટિપ્પણી",
    "1249": "અન્ય ફાળો - ફાઈલો",
    "1250": "GF તરફથી મહત્તમ યોગદાન",
    "1251": "હોસ્પિટલ નામ",
    "1252": "ઉપચાર કરનાર ડૉક્ટર",
    "1253": "મને સંમતિ ફોર્મ, અરજી ફોર્મ અને ઘોષણા ફોર્મની એક નકલ આપવામાં આવી છે",
    "1254": "ઉપર આપવામાં આવેલ માહિતી સત્ય અને સંપૂર્ણ છે",
    "1255": "હું ઉપર જણાવેલ મારા બાળકની (લાભાર્થી) સારવારનો ખર્ચ ઉઠાવવા સક્ષમ નથી",
    "1263": "હું સ્વીકાર કરું છું કે બાળકની સારવાર માટે નાણાકીય અને અન્ય સહાયતા એક નિઃશુલ્ક અને પરોપકારી ભાવથી આપવામાં આવી રહી છે. હું ખાતરી આપું છું કે જેનેસિસ ફાઉન્ડેશન, તેના ટ્રસ્ટી, અધિકારીઓ, કર્મચારીઓ અને સ્વયંસેવકો મારા બાળકની સારવાર સંદર્ભે કોઈ જવાબદારી ધરાવશે નહીં.",
    "1257": "શું માતા-પિતા/વાલી ઉપરોક્ત તમામ ઘોષણાઓ સાથે સહમત છે?",
    "1258": "અરજી ફોર્મ ભરનાર",
    "1259": "હોદ્દો",
    "1260": "જન્મ પ્રમાણપત્ર દસ્તાવેજ",
    "1261": "શસ્ત્રક્રિયા પહેલાં લાભાર્થીનો ફોટો",
    "1264": "હું પુષ્ટિ કરું છું કે માન્ય જન્મ પ્રમાણપત્ર સબમિટ કરવામાં આવ્યું છે. તેથી, લાભાર્થીની ચકાસણી વિગત આવશ્યક નથી અને ચકાસણી વિભાગ છોડી શકાય છે.",
    "1265": "લાભાર્થીનું નામ",
    "1266": "લાભાર્થીનું લિંગ",
    "1267": "લાભાર્થીના ઓળખ પુરાવાની ચકાસણી",
    "1269": "લાભાર્થીની માતાનું નામ",
    "1270": "માતાની આધાર અને મતદાર ઓળખ ચકાસણી",
    "1271": "માતાની મતદાર ઓળખ ચકાસણી",
    "1272": "લાભાર્થીના પિતાનું નામ",
    "1273": "પિતાની આધાર અને મતદાર ઓળખ ચકાસણી",
    "1274": "પિતાની મતદાર ઓળખ ચકાસણી",
    "1275": "કમાણી કરતા કૌટુંબિક સભ્યનું નામ",
    "1276": "માસિક આવક",
    "1277": "વાર્ષિક આવક",
    "1278": "સબમિટ કરેલ આવક પ્રૂફની ભાષા",
    "1279": "હોસ્પિટલ પ્રતિનિધિનું નામ",
    "1280": "હોસ્પિટલ પ્રતિનિધિનો હોદ્દો",
    "1281": "હું, {name}, હોદ્દો {designation}, ઉપર દર્શાવેલ દરેક આધાર કાર્ડ/મતદાતા ઓળખપત્ર અને આવકનો પુરાવો (સ્થાનિક ભાષાઓમાં હોય તે સહિત) જોયો છે અને ખાતરી કરું છું કે વિગતો અરજીપત્રકમાં આપેલી વિગતો સાથે સુસંગત છે.",
    "1285": "ઉચ્ચ શિક્ષણ લાયકાત",
    "1286": "માતાના ઓળખ પ્રમાણ પ્રકાર",
    "1287": "પિતાના ઓળખ પ્રમાણ પ્રકાર",
    "1288": "વાલીના ઓળખ પ્રમાણ પ્રકાર",
    "1289": "માતાનો આધાર કાર્ડ નંબર",
    "1290": "માતાનો મતદાર કાર્ડ નંબર",
    "1291": "પિતાનો આધાર કાર્ડ નંબર",
    "1292": "પિતાનો મતદાર કાર્ડ નંબર",
    "1293": "વાલીનો આધાર કાર્ડ નંબર",
    "1294": "વાલીનો મતદાર કાર્ડ નંબર",
    "1295": "વાલીનો સંબંધ",
    "1296": "જન્મજાત હૃદય રોગ કેસ - ટિપ્પણી - કૃપા કરીને ઉલ્લેખ કરો",
    "1297": "ઇકો રિપોર્ટ દસ્તાવેજ",
    "1298": "અંદાજ પત્ર દસ્તાવેજ",
    "1299": "આવક પ્રમાણ દસ્તાવેજ",
    "1300": "કુટુંબ ફોટો",
    "1301": "વાલીની આધાર અને મતદાર ઓળખ ચકાસણી",
  },

  Marathi: {
    "1128": "संमतीची भाषा",
    "1132": "संमती स्वाक्षरी विभाग",
    "1131": "कृतीचा प्रकार",
    "1133": "ज्यासाठी संमती स्वाक्षरी केली आहे",
    "1134": "संमती स्वाक्षरीकर्ता",
    "1135": "संमती जोडपत्र",
    "1136": "रद्द करण्याचे कारण",
    "1137": "तारीख",
    "1138": "रद्द होण्याची प्रभावी तारीख",
    "1282": "ज्यासाठी संमती स्वाक्षरी केलेली नाही",
    "1283": "पालकाचे नाव",
    "1284": "पालकाचे नाते",
    "1139": "संमतीची अंतिम स्थिती",
    "1140": "प्रकरण प्राप्त तारीख",
    "1141": "प्रकरणाचा स्त्रोत",
    "1142": "इतर असल्यास, कृपया नमूद करा",
    "1143": "GF समर्थित तपासणी शिबिर",
    "1144": "तपासणी शिबिर रुग्णालय स्थान",
    "1145": "आउटरीच OPD स्थान",
    "1146": "संदर्भित रुग्णालयाचे नाव",
    "1147": "संदर्भित रुग्णालयाचे स्थान",
    "1148": "लाभार्थीचे पूर्ण नाव",
    "1149": "टोपणनाव / इतर नाव",
    "1150": "वय मूल्य",
    "1151": "वयाचे एकक (दिवस/महिने/वर्षामध्ये)",
    "1152": "वय श्रेणी",
    "1153": "लिंग",
    "1154": "धर्म",
    "1155": "शरीराचे वजन (किलोग्रॅम)",
    "1156": "शैक्षणिक स्थिती",
    "1157": "शाळा/कॉलेजचे नाव",
    "1158": "लाभार्थी ओळख पुरावा",
    "1159": "आधार कार्ड क्रमांक",
    "1160": "रुग्णालयाद्वारे आधार कार्ड तपासणी?",
    "1161": "जन्म प्रमाणपत्र GF शी सामायिक केले",
    "1162": "पडताळणी फॉर्म रुग्णालयाने भरलेला आणि स्वाक्षरी केलेला",
    "1163": "पालकांची स्थिती",
    "1164": "मूल कोणासोबत राहत आहे",
    "1165": "आईचे नाव",
    "1166": "आईचे वय",
    "1167": "आईचा व्यवसाय",
    "1168": "आईचे मासिक उत्पन्न",
    "1169": "वडिलांचे नाव",
    "1170": "वडिलांचे वय",
    "1171": "वडिलांचा व्यवसाय",
    "1172": "वडिलांचे मासिक उत्पन्न",
    "1173": "पालकाचे नाव",
    "1174": "पालकाचे वय",
    "1175": "पालकाचा व्यवसाय",
    "1176": "पालकाचे मासिक उत्पन्न",
    "1177": "एकूण कौटुंबिक उत्पन्न",
    "1178": "पत्त्याचा स्त्रोत",
    "1179": "पूर्ण पत्ता",
    "1180": "प्राथमिक संपर्क व्यक्ती",
    "1181": "प्राथमिक संपर्क क्रमांक",
    "1182": "पर्यायी संपर्क क्रमांक",
    "1183": "लाभार्थीच्या भावंडांची संख्या",
    "1184": "लाभार्थीचा कायम पत्ता",
    "1185": "राज्य",
    "1186": "पालक/पाळकाचा प्रदेश",
    "1206": "जिल्हा",
    "1207": "हा आकांक्षी जिल्हा आहे का?",
    "1208": "गाव/भागाचे नाव",
    "1209": "भौगोलिक वर्गीकरण",
    "1210": "आदिवासी भाग",
    "1211": "जन्मजात हृदय दोषाचे प्रकरण आहे का?",
    "1212": "शस्त्रक्रियेपूर्वीची लक्षणे",
    "1213": "प्रकरणाचा प्रकार",
    "1229": "निदान",
    "1230": "निश्चित केलेले उपचार",
    "1231": "शस्त्रक्रियेचा प्रकार",
    "1232": "व्हीएसडी डिव्हाइस क्लोजर आहे का?",
    "1233": "सिंगल व्हेंट्रिकल फिजिओलॉजी आहे का?",
    "1234": "हायपोप्लास्टिक हार्ट आहे का?",
    "1235": "डाउन्स सिंड्रोम किंवा इतर जनुकीय दोषासह सीएचडी प्रकरण आहे का?",
    "1236": "हृदय प्रत्यारोपणाची आवश्यकता आहे का?",
    "1237": "पुन्हा शस्त्रक्रिया (री-डू) आहे का?",
    "1238": "व्हॉल्व्ह दुरुस्ती/बदली आहे का?",
    "1239": "या बालकाला पूर्वी जीएफने मदत केली आहे का?",
    "1240": "लाभार्थीचा संक्षिप्त वैद्यकीय तपशील",
    "1241": "शस्त्रक्रियेची अंदाजित किंमत",
    "1242": "कुटुंबाचे अंदाजे योगदान",
    "1243": "रुग्णालयाची अंदाजे सवलत",
    "1244": "कौटुंबिक योगदानाचा स्त्रोत",
    "1245": "रुग्णालय चॅरिटी सेलचे अंदाजे योगदान",
    "1246": "इतर योगदान रक्कम",
    "1247": "रुग्णालय चॅरिटी सेल - टिप्पणी",
    "1248": "इतर योगदान - टिप्पणी",
    "1249": "इतर योगदान - फाइल्स",
    "1250": "जीएफचे जास्तीत जास्त योगदान",
    "1251": "रुग्णालयाचे नाव",
    "1252": "उपचार करणारे डॉक्टर",
    "1253": "मला संमती फॉर्म, अर्ज फॉर्म आणि घोषणा फॉर्मची एक प्रत देण्यात आली आहे",
    "1254": "वर दिलेली माहिती सत्य आणि पूर्ण आहे",
    "1255": "वर वर्णन केलेल्या माझ्या पाल्याच्या (लाभार्थी) उपचाराचा खर्च भागवणे माझ्यासाठी शक्य नाही",
    "1263": "मी मान्य करतो/करते की मुलाच्या उपचारासाठी आर्थिक आणि इतर मदत एक नि:शुल्क आणि परोपकारी भावनेने दिली जात आहे. जेनेसिस फाउंडेशन, तेथील विश्वस्त, अधिकारी, कर्मचारी आणि स्वयंसेवक माझ्या मुलाच्या उपचाराशी संबंधित कोणत्याही जबाबदारीस बांधील नाहीत याची मी खात्री देतो/देते.",
    "1257": "पालक/पाळक वरील सर्व घोषणांशी सहमत आहेत का?",
    "1258": "अर्ज फॉर्म भरणारा",
    "1259": "पद",
    "1260": "जन्म प्रमाणपत्र दस्तऐवज",
    "1261": "शस्त्रक्रियेपूर्वी लाभार्थीचा फोटो",
    "1264": "मी पुष्टी करतो/करते की एक वैध जन्म प्रमाणपत्र सादर केले आहे. त्यामुळे लाभार्थीचे सत्यापन तपशील आवश्यक नाहीत आणि सत्यापन विभाग वगळता येतो.",
    "1265": "लाभार्थीचे नाव",
    "1266": "लाभार्थीचे लिंग",
    "1267": "लाभार्थी ओळख पुरावा पडताळणी",
    "1269": "लाभार्थीच्या आईचे नाव",
    "1270": "आईचे आधार व मतदार ओळखपत्र पडताळणी",
    "1271": "आईची मतदार ओळखपत्र पडताळणी",
    "1272": "लाभार्थीच्या वडिलांचे नाव",
    "1273": "वडिलांचे आधार व मतदार ओळखपत्र पडताळणी",
    "1274": "वडिलांची मतदार ओळखपत्र पडताळणी",
    "1275": "कमावत्या कुटुंबातील सदस्याचे नाव",
    "1276": "मासिक उत्पन्न",
    "1277": "वार्षिक उत्पन्न",
    "1278": "सादर केलेल्या उत्पन्न पुराव्याची भाषा",
    "1279": "रुग्णालय प्रतिनिधीचे नाव",
    "1280": "रुग्णालय प्रतिनिधीचे पद",
    "1281": "मी, {name}, पद {designation}, वर नमूद केलेले प्रत्येक आधार कार्ड/मतदार ओळखपत्र आणि उत्पन्न पुरावा (स्थानिक भाषांमधील पुराव्यांसह) पाहिले असून अर्ज फॉर्ममधील तपशिलांशी ते जुळत असल्याची खात्री करतो/करते।",
    "1285": "उच्च शिक्षण पात्रता",
    "1286": "आईचा ओळख पुरावा प्रकार",
    "1287": "वडिलांचा ओळख पुरावा प्रकार",
    "1288": "पालकाचा ओळख पुरावा प्रकार",
    "1289": "आईचा आधार कार्ड क्रमांक",
    "1290": "आईचा मतदार कार्ड क्रमांक",
    "1291": "वडिलांचा आधार कार्ड क्रमांक",
    "1292": "वडिलांचा मतदार कार्ड क्रमांक",
    "1293": "पालकाचा आधार कार्ड क्रमांक",
    "1294": "पालकाचा मतदार कार्ड क्रमांक",
    "1295": "पालकाचे नाते",
    "1296": "जन्मजात हृदय दोष प्रकरण - टिप्पणी - कृपया नमूद करा",
    "1297": "इकोकार्डियोग्राम अहवाल दस्तऐवज",
    "1298": "अंदाजपत्रक दस्तऐवज",
    "1299": "उत्पन्न पुरावा दस्तऐवज",
    "1300": "कौटुंबिक फोटो",
    "1301": "पालकाचे आधार व मतदार ओळखपत्र पडताळणी",
  },
};

export function getColumnLabel(column, activeLanguage) {
  if (
    activeLanguage &&
    GF_COLUMN_TRANSLATIONS[activeLanguage] &&
    GF_COLUMN_TRANSLATIONS[activeLanguage][String(column.id)]
  ) {
    return GF_COLUMN_TRANSLATIONS[activeLanguage][String(column.id)];
  }
  return column.name;
}

export function getEnglishColumnLabel(column) {
  const id = String(column?.id ?? "");
  return (
    (GF_COLUMN_TRANSLATIONS["English"] && GF_COLUMN_TRANSLATIONS["English"][id]) ||
    column?.name ||
    ""
  );
}

export const GF_SECTION_TITLE_TRANSLATIONS = {
  English: {
    "consent": "Consent & Authorization",
    "case_info": "Case Information",
    "beneficiary": "Beneficiary Details",
    "family": "Family Details",
    "address": "Address Details",
    "medical": "Beneficiary Medical Details",
    "financial": "Financial Assistance Details",
    "hospital": "Hospital Details",
    "declaration": "Declaration",
    "verification": "Verification Form",
    "verification_beneficiary": "Aadhaar/Voter ID Verification Details of Beneficiary",
    "verification_parents": "Aadhaar/Voter ID Verification Details of Parents/Legal Guardian",
    "verification_income": "Income Proof Verification Details",
    "verification_hospital": "Hospital Representative & Declaration",
  },
  Assamese: {
    "consent": "সন্মতি আৰু অনুমোদন",
    "case_info": "গোচৰৰ তথ্য",
    "beneficiary": "সুবিধাভোগীৰ বিৱৰণ",
    "family": "পৰিয়ালৰ বিৱৰণ",
    "address": "ঠিকনাৰ বিৱৰণ",
    "medical": "সুবিধাভোগীৰ চিকিৎসাগত বিৱৰণ",
    "financial": "আৰ্থিক সহায়তাৰ বিৱৰণ",
    "hospital": "চিকিৎসালয়ৰ বিৱৰণ",
    "declaration": "ঘোষণা",
    "verification": "যাচাইকৰণ প্ৰপত্ৰ",
    "verification_beneficiary": "সুবিধাভোগীৰ আধাৰ/ভোটাৰ আইডি যাচাইকৰণৰ বিৱৰণ",
    "verification_parents": "অভিভাৱকৰ আধাৰ/ভোটাৰ আইডি যাচাইকৰণৰ বিৱৰণ",
    "verification_income": "আয়ৰ প্ৰমাণপত্ৰ যাচাইকৰণৰ বিৱৰণ",
    "verification_hospital": "চিকিৎসালয়ৰ প্ৰতিনিধি আৰু ঘোষণা",
  },
  Bengali: {
    "consent": "সম্মতি ও অনুমোদন",
    "case_info": "মামলার তথ্য",
    "beneficiary": "সুবিধাভোগীর বিবরণ",
    "family": "পারিবারিক বিবরণ",
    "address": "ঠিকানার বিবরণ",
    "medical": "সুবিধাভোগীর চিকিৎসা বিবরণ",
    "financial": "আর্থিক সহায়তার বিবরণ",
    "hospital": "হাসপাতালের বিবরণ",
    "declaration": "ঘোষণা",
    "verification": "যাচাইকরণ ফর্ম",
    "verification_beneficiary": "সুবিধাভোগীর আধার/ভোটার আইডি যাচাইকরণের বিবরণ",
    "verification_parents": "পিতামাতা/আইনগত অভিভাবকের আধার/ভোটার আইডি যাচাইকরণের বিবরণ",
    "verification_income": "আয় প্রমাণ যাচাইকরণের বিবরণ",
    "verification_hospital": "হাসপাতালের প্রতিনিধি এবং ঘোষণা",
  },
  Hindi: {
    "consent": "सहमति और अनुमोदन",
    "case_info": "मामले की जानकारी",
    "beneficiary": "लाभार्थी विवरण",
    "family": "पारिवारिक विवरण",
    "address": "पते का विवरण",
    "medical": "लाभार्थी के चिकित्सा विवरण",
    "financial": "वित्तीय सहायता विवरण",
    "hospital": "अस्पताल विवरण",
    "declaration": "घोषणा",
    "verification": "सत्यापन फॉर्म",
    "verification_beneficiary": "लाभार्थी के आधार/वोटर आईडी सत्यापन विवरण",
    "verification_parents": "माता-पिता/कानूनी अभिभावक के आधार/वोटर आईडी सत्यापन विवरण",
    "verification_income": "आय प्रमाण सत्यापन विवरण",
    "verification_hospital": "अस्पताल प्रतिनिधि और घोषणा",
  },
  Tamil: {
    "consent": "ஒப்புதல் மற்றும் அங்கீகாரம்",
    "case_info": "வழக்கு தகவல்",
    "beneficiary": "பயனாளி விவரங்கள்",
    "family": "குடும்ப விவரங்கள்",
    "address": "முகவரி விவரங்கள்",
    "medical": "பயனாளியின் மருத்துவ விவரங்கள்",
    "financial": "நிதி உதவி விவரங்கள்",
    "hospital": "மருத்துவமனை விவரங்கள்",
    "declaration": "அறிவிப்பு",
    "verification": "சரிபார்ப்பு படிவம்",
    "verification_beneficiary": "பயனாளியின் ஆதார்/வாக்காளர் அடையாள அட்டை சரிபார்ப்பு விவரங்கள்",
    "verification_parents": "பெற்றோர்/சட்டப்பூர்வ பாதுகாவலரின் ஆதார்/வாக்காளர் அடையாள அட்டை சரிபார்ப்பு விவரங்கள்",
    "verification_income": "வருமானச் சான்று சரிபார்ப்பு விவரங்கள்",
    "verification_hospital": "மருத்துவமனை பிரதிநிதி & அறிவிப்பு",
  },
  Telugu: {
    "consent": "సమ్మతి మరియు అనుమతి",
    "case_info": "కేసు సమాచారం",
    "beneficiary": "లబ్ధిదారు వివరాలు",
    "family": "కుటుంబ వివరాలు",
    "address": "చిరునామా వివరాలు",
    "medical": "లబ్ధిదారు వైద్య వివరాలు",
    "financial": "ఆర్థిక సహాయ వివరాలు",
    "hospital": "ఆసుపత్రి వివరాలు",
    "declaration": "ప్రకటన",
    "verification": "ధృవీకరణ పత్రం",
    "verification_beneficiary": "లబ్ధిదారు యొక్క ఆధార్/ఓటర్ ఐడి ధృవీకరణ వివరాలు",
    "verification_parents": "తల్లిదండ్రులు/చట్టపరమైన సంరక్షకుల ఆధార్/ఓటర్ ఐడి ధృవీకరణ వివరాలు",
    "verification_income": "ఆదాయ నిరూపణ ధృవీకరణ వివరాలు",
    "verification_hospital": "ఆసుపత్రి ప్రతినిధి & ప్రకటన",
  },
  Marathi: {
    "consent": "संमती आणि मंजुरी",
    "case_info": "प्रकरणाची माहिती",
    "beneficiary": "लाभार्थी तपशील",
    "family": "कौटुंबिक तपशील",
    "address": "पत्त्याचा तपशील",
    "medical": "लाभार्थीचे वैद्यकीय तपशील",
    "financial": "आर्थिक सहाय्य तपशील",
    "hospital": "रुग्णालय तपशील",
    "declaration": "घोषणा",
    "verification": "पडताळणी अर्ज",
    "verification_beneficiary": "लाभार्थीचे आधार/मतदार ओळखपत्र पडताळणी तपशील",
    "verification_parents": "पालकांचे आधार/मतदार ओळखपत्र पडताळणी तपशील",
    "verification_income": "उत्पन्न पुरावा पडताळणी तपशील",
    "verification_hospital": "रुग्णालय प्रतिनिधी आणि घोषणा",
  },
  Gujarati: {
    "consent": "સંમતિ અને મંજૂરી",
    "case_info": "કેસ માહિતી",
    "beneficiary": "લાભાર્થી વિગત",
    "family": "કૌટુંબિક વિગત",
    "address": "સરનામાની વિગત",
    "medical": "લાભાર્થીની તબીબી વિગત",
    "financial": "આર્થિક સહાય વિગત",
    "hospital": "હોસ્પિટલ વિગત",
    "declaration": "ઘોષણા",
    "verification": "ચકાસણી પત્રક",
    "verification_beneficiary": "લાભાર્થીની આધાર/મતદાતા ઓળખપત્ર ચકાસણી વિગત",
    "verification_parents": "માતાપિતા/કાયદેસરના વાલીની આધાર/મતદાતા ઓળખપત્ર ચકાસણી વિગત",
    "verification_income": "આવકનો પુરાવો ચકાસણી વિગત",
    "verification_hospital": "હોસ્પિટલ પ્રતિનિધિ અને ઘોષણા",
  },
  Punjabi: {
    "consent": "ਸਹਿਮਤੀ ਅਤੇ ਪ੍ਰਵਾਨਗੀ",
    "case_info": "ਕੇਸ ਜਾਣਕਾਰੀ",
    "beneficiary": "ਲਾਭਪਾਤਰੀ ਵੇਰਵੇ",
    "family": "ਪਰਿਵਾਰਕ ਵੇਰਵੇ",
    "address": "ਪਤੇ ਦੇ ਵੇਰਵੇ",
    "medical": "ਲਾਭਪਾਤਰੀ ਦੇ ਡਾਕਟਰੀ ਵੇਰਵੇ",
    "financial": "ਵਿੱਤੀ ਸਹਾਇਤਾ ਵੇਰਵੇ",
    "hospital": "ਹਸਪਤਾਲ ਵੇਰਵੇ",
    "declaration": "ਘੋਸ਼ਣਾ",
    "verification": "ਤਸਦੀਕ ਫਾਰਮ",
    "verification_beneficiary": "ਲਾਭਪਾਤਰੀ ਦੀ ਆਧਾਰ/ਵੋਟਰ ਆਈਡੀ ਤਸਦੀਕ ਦੇ ਵੇਰਵੇ",
    "verification_parents": "ਮਾਪਿਆਂ/ਕਾਨੂੰਨੀ ਸਰਪ੍ਰਸਤ ਦੀ ਆਧਾਰ/ਵੋਟਰ ਆਈਡੀ ਤਸਦੀਕ ਦੇ ਵੇਰਵੇ",
    "verification_income": "ਆਮਦਨ ਸਬੂਤ ਤਸਦੀਕ ਦੇ ਵੇਰਵੇ",
    "verification_hospital": "ਹਸਪਤਾਲ ਪ੍ਰਤੀਨਿਧੀ ਅਤੇ ਘੋਸ਼ਣਾ",
  },
  Kannada: {
    "consent": "ಸಮ್ಮತಿ ಮತ್ತು ಅನುಮೋದನೆ",
    "case_info": "ಪ್ರಕರಣ ಮಾಹಿತಿ",
    "beneficiary": "ಫಲಾನುಭವಿ ವಿವರ",
    "family": "ಕುಟುಂಬ ವಿವರ",
    "address": "ವಿಳಾಸ ವಿವರ",
    "medical": "ಫಲಾನುಭವಿಯ ವೈದ್ಯಕೀಯ ವಿವರ",
    "financial": "ಆರ್ಥಿಕ ಸಹಾಯ ವಿವರ",
    "hospital": "ಆಸ್ಪತ್ರೆ ವಿವರ",
    "declaration": "ಘೋಷಣೆ",
    "verification": "ಪರಿಶೀಲನಾ ನಮೂನೆ",
    "verification_beneficiary": "ಫಲಾನುಭವಿಯ ಆಧಾರ್/ಮತದಾರರ ಗುರುತಿನ ಚೀಟಿ ಪರಿಶೀಲನೆ ವಿವರಗಳು",
    "verification_parents": "ಪೋಷಕರು/ಕಾನೂನುಬದ್ಧ ರಕ್ಷಕರ ಆಧಾರ್/ಮತದಾರರ ಗುರುತಿನ ಚೀಟಿ ಪರಿಶೀಲನೆ ವಿವರಗಳು",
    "verification_income": "ಆದಾಯ ಪುರಾವೆ ಪರಿಶೀಲನೆ ವಿವರಗಳು",
    "verification_hospital": "ಆಸ್ಪತ್ರೆ ಪ್ರತಿನಿಧಿ ಮತ್ತು ಘೋಷಣೆ",
  },
  Malayalam: {
    "consent": "സമ്മതവും അംഗീകാരവും",
    "case_info": "കേസ് വിവരങ്ങൾ",
    "beneficiary": "ഗുണഭോക്താവിന്റെ വിശദാംശങ്ങൾ",
    "family": "കുടുംബ വിശദാംശങ്ങൾ",
    "address": "മേൽവിലാസ വിശദാംശങ്ങൾ",
    "medical": "ഗുണഭോക്താവിന്റെ വൈദ്യ വിശദാംശങ്ങൾ",
    "financial": "സാമ്പത്തിക സഹായ വിശദാംശങ്ങൾ",
    "hospital": "ആശുപത്രി വിശദാംശങ്ങൾ",
    "declaration": "പ്രഖ്യാപനം",
    "verification": "സ്ഥിരീകരണ ഫോം",
    "verification_beneficiary": "ഗുണഭോക്താവിന്റെ ആധാർ/വോട്ടർ ഐഡി സ്ഥിരീകരണ വിശദാംശങ്ങൾ",
    "verification_parents": "രക്ഷിതാക്കളുടെ ആധാർ/വോട്ടർ ഐഡി സ്ഥിരീകരണ വിശദാംശങ്ങൾ",
    "verification_income": "വരുമാന തെളിവ് സ്ഥിരീകരണ വിശദാംശങ്ങൾ",
    "verification_hospital": "ആശുപത്രി പ്രതിനിധിയും പ്രഖ്യാപനവും",
  },
  Odia: {
    "consent": "ସମ୍ମତି ଓ ଅନୁମୋଦନ",
    "case_info": "ମାମଲାର ତଥ୍ୟ",
    "beneficiary": "ସୁବିଧାଭୋଗୀ ବିବରଣ",
    "family": "ପରିବାର ବିବରଣ",
    "address": "ଠିକଣା ବିବରଣ",
    "medical": "ସୁବିଧାଭୋଗୀଙ୍କ ଚିକିତ୍ସା ବିବରଣ",
    "financial": "ଆର୍ଥିକ ସହାୟତା ବିବରଣ",
    "hospital": "ଡାକ୍ତରଖାନା ବିବରଣ",
    "declaration": "ଘୋଷଣା",
    "verification": "ଯାଞ୍ଚ ଫର୍ମ",
    "verification_beneficiary": "ସୁବିଧାଭୋଗୀଙ୍କ ଆଧାର/ଭୋଟର ଆଇଡ଼ି ଯାଞ୍ଚ ବିବରଣୀ",
    "verification_parents": "ପିତାମାତା/ଆଇନଗତ ଅଭିଭାବକଙ୍କ ଆଧାର/ଭୋଟର ଆଇଡ଼ି ଯାଞ୍ଚ ବିବରଣୀ",
    "verification_income": "ଆୟ ପ୍ରମାଣପତ୍ର ଯାଞ୍ଚ ବିବରଣୀ",
    "verification_hospital": "ଡାକ୍ତରଖାନା ପ୍ରତିନିଧି ଏବଂ ଘୋଷଣା",
  },
};

export function getSectionTitle(sectionId, sectionTitleEn, activeLanguage) {
  if (activeLanguage && GF_SECTION_TITLE_TRANSLATIONS[activeLanguage]?.[sectionId]) {
    return GF_SECTION_TITLE_TRANSLATIONS[activeLanguage][sectionId];
  }
  return sectionTitleEn;
}
